// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Assets/Images/4105860_2152177.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  display: flex;
  flex-direction: column;
}

.route-loading {
  min-height: 40vh;
  display: grid;
  place-items: center;
  padding: 2rem;
  color: #4b5563;
  font-size: 0.95rem;
}
/* customDatepicker.css */

.inputdate1 {
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  border-bottom: 1px solid #989898 !important;
  border-radius: 0 !important;
  margin-bottom: 20px;
  outline: none;
  background-color: transparent !important;
}

.table-expanded-row {
  display: flex;
  justify-content: space-around;
  text-align: center;
}

.show-mobile{
  display: none;
}

.plan-history-filter-container{
  display: flex;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin: auto;
  padding:20px;
  border-radius: 10px;
}

@media (max-width: 767px) {
  .cprogress

  {
    height:90px;
    width:90px;
  }
  .userdp
  {
    height:80px;
    width:80px;
    border-radius: 120px;
  }
  .web_nav {
    display: none !important;
  }
  

  .myCarousel {
    background: #fafafa;
    margin-top: -12%;
    width: 98%;
    margin-left: auto;
    margin-right: auto;
    padding-top: 6%;
    padding-bottom: 8%;
    padding-left: 5%;
    padding-right: 5%;
    border: 1px solid #ddd;
    height: 230px;
  }
  .hide-mobile {
    display: none;
  }
  .table-cell {
    padding: 7px !important;
    font-size: small;
  }
  .table-arrow{
    width: 15px;
  }
  .table-expanded-row{
    gap: 5px;
    flex-wrap: wrap;
  }
  .table-expanded-row > * {
    flex: 0 0 45%;
    box-sizing: border-box;
  }
  .show-mobile{
    display: block;
  }
  .plan-history-filter-container{
    justify-content: center;
    /* width: 350px; */
  }
}
@media (min-width: 767px) {
  .cprogress

{
  height:115px;
  width:115px;
}
.userdp
{
  height:100px;
  width:100px;
  border-radius: 120px;
}
  .mob_nav {
    display: none;
  }
  .myCarousel {
    background: #fafafa;
    margin-top: -12%;
    width: 98%;
    margin-left: auto;
    margin-right: auto;
    padding-top: 6%;
    padding-bottom: 8%;
    padding-left: 5%;
    padding-right: 5%;
    border: 1px solid #ddd;
    height: 35dvh;
  }
  
 
}
@media (max-width: 1180px) {
.dashbar{
  width:22%;
}
}
@media (max-width: 768px) {
  .filter_parent {
    display: none !important;
  }
}


.pac-container {
  z-index:1000 !important;
  position: absolute;
}


.checkout-con-1{
    /* outline: red solid; */
    display: flex;
    align-content: center;
}

@media (max-width: 767px) {
  .filter_parent_application {
    display: none !important;
  }
}

@media (max-width: 767px) {
  .hide_img {
    display: none !important;
  }
  .checkout-con-1{
    flex-direction: column;
    padding: 10px;
  }
}
@media (min-width: 920px) {
  .display_img {
    display: none !important;
  }
}

:root {
  margin: 0;
  padding: 0;
}
.input1 {
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  border-bottom: 1px solid #989898 !important;
  border-radius: 0 !important;
  margin-bottom: 20px;
  outline: none;

  background-color: transparent !important;
}


.input1:focus {
  box-shadow: none !important;
  border-bottom: 1px solid #ff5c09 !important;
}
.input1:hover {
  outline: none !important;
  border-bottom: 1px solid #ff5c09 !important;
}



.forgot_password {
  color: #ff5c09;
  cursor: pointer;
  text-decoration: underline;
}



.nav_login {
  background-color: #ff5c09;
  border: none;
  border-radius: 8px;
  color: #ffffff !important;
  padding: 8px 20px;
  width:150px;
}
/* .nav_login:hover {
  background-color: white;
  border: 2px solid #3352D0;
  border-radius: 8px;
  color: #000000;
  padding: 8px 20px;
  transition: 500ms;
} */

.nav_cook_login {
  background-color: #00b0a0;
  border: none;
  border-radius: 8px;
  color: #000000;
  padding: 8px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav_cook_login:hover {
  background-color: white;
  border: 2px solid #00b0a0;
  border-radius: 8px;
  color: #000000;
  padding: 8px 20px;
  transition: 500ms;
  display: flex;
  justify-content: center;
  align-items: center;
}

.signup_btn {
  border: 2px solid #ff5c09 !important;
  border-radius: 8px;
  color: #ff5c09;
  padding: 8px 20px;
}
.signup_btn:hover {
  background-color: #ff5c09 !important;
  border: none;
  border-radius: 8px;
  color: white;
  padding: 8px 20px;
  transition: 800ms;
}
.terms_and_conditions {
  color: #ff5c09;
  font-weight: 500;
  cursor: pointer;
  font-size: 12px;
  text-wrap: wrap;
}
.toggle_button {
  color: #ff5c09;
  border: 2px solid #ff5c09;
  border-radius: 8px;
  padding: 8px 20px;
  background-color: white;
}
.toggle_button:hover {
  background-color: #ff5c09;
  color: white;
  transition: 500ms;
}
.toggle_button_active {
  border-radius: 8px;
  border: none;
  padding: 8px 20px;
  background-color: #ff5c09;
  color: white;
}

.login_btn {
  height: 48px !important;
  width: 200px !important;
  border-radius: 50px !important;
  background-color: #ff5c09 !important;
  color: #ffffff;
  border-radius: 15px !important;
  border: none !important;
  font-size: 18px;
}
.sidebar {
  /* height: 600px; */
  padding: 14px;
  width: "100%";
  background-color: white;
  border-radius: 15px;
  box-shadow: 0px 0px 17px -1px rgba(0, 0, 0, 0.16);

}


.sidebar-menu-body {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: 8px 8px 8px 0px;

}

.sidebar-menu-nav {
  height: 30px;
  width: 230px;
  padding: 5px 5px;
  /* border-bottom: solid 1px #e6e3e3; */
  display: flex;
  justify-content: flex-start;
  align-items: left;
  cursor: pointer;
  margin-left: -19px;
  transition: 500ms;

  
}


.sidebar-menu-nav-link {
  color: #000000;
  padding:5px 5px 5px 20px;
}



.sidebar-menu-nav .active-link {
  color:#fff;
  background:#ff5c09;
  padding:5px 5px 5px 20px;
  width:100%;
height:34px;
}
.sidebar-menu-nav .active-links {
  color:#fff;
  background:#ff5c09;
  padding:5px 10px 5px 10px;
  width:100%;
height:34px;
}
@media only screen and (max-width: 767px) {
.arrow{justify-content: end;
}
}

@media only screen and (min-width: 768px) {
  .arrow{
  justify-content: end;
  }
  }
@media screen and (min-width: 1200px) {
  .sidebar-menu-nav .active-link {
    color:#fff;
    background:#ff5c09;
    padding:5px 5px 5px 20px;
    width:94%;
  height:34px;
  }
  

  .sidebar-menu-nav .active-links {
    color:#fff;
    background:#ff5c09;
    padding:5px 10px 5px 10px;
    width:94%;
  height:34px;
  }
 
}

@media only screen and (min-width: 1024px) and (max-width: 1199px) {
  .sidebar-menu-nav .active-link {
    color:#fff;
    background:#ff5c09;
    padding:5px 5px 5px 20px;
    width:65%;
  height:34px;
  }
  .sidebar-menu-nav .active-links {
    color:#fff;
    background:#ff5c09;
    padding:5px 10px 5px 10px;
    width:65%;
  height:34px;
  }
  
}

.sidebar-menu-nav:hover {
 
  .sidebar-menu-nav-link {
    /* color: #ff5c09; */
    /* border-radius: 10px;
    */
  transition: color 0.8s ease;
  

  }
}


.sidebar-menu-sub {
  width: 300px;
  padding: 5px 5px;
}

.sidebar-menu-sub-toggle {
  border: none;
  background-color: transparent;
}

.dash_card {
  height: auto;
  width: 100%;
  background-color: white;
  border-radius: 15px;
  padding: 10px;
}

.navMenu {
  color: #000000 !important;
  font-weight: 400;
}
.search_parent {
  padding: 4px;
  border-radius: 15px;
  border: 2px solid #9e9e9e;
}
.search_parent:hover {
  border: 2px solid #ff5c09;
}
.search_parent:focus {
  border: 2px solid #ff5c09;
}
.search {
  border: none !important;
  border-radius: 30px !important;
  background-color: transparent !important;
}
.search:focus {
  box-shadow: none !important;
}

.view_profile {
  background-color: #fff !important;
  height: 25px;
  width: 75px;
  box-shadow: none !important;
  border-radius: 5px !important;
  font-size: 12px !important;
  padding: 0 !important;
  margin: 0 !important;
  text-transform: capitalize !important;
  color:#ff5c09;
  padding:5px;
  border: solid 1px #ff5c09;
}
.view_profile:hover {
  background-color: #fff !important;
  height: 26px;
  width: 76px;
  padding:5px;
  box-shadow: none !important;
  border-radius: 5px !important;
  font-size: 12px !important;
  padding: 0 !important;
  margin: 0 !important;
  text-transform: capitalize !important;
  color:#ff5c09 !important;
  border: solid 1px #ff5c09 !important;
}
.filter_btn {
  background-color: transparent !important ;
  color: #ff5c09 !important;
  text-transform: capitalize !important;
  box-shadow: none !important;
  padding:8px;
  margin-bottom: 10px;
  font-size: 18px !important;
  font-weight: 600 !important;
 
  border: none;
}

.banner_child {
  width: 40%;
  min-height: 75%;
  background-color: #ff5c09;
  border-radius: 50%;
  position: absolute;
  bottom: 5%;
  right: 10%;
}
.box {
  height: 15%;
  width: 25%;
  background-color: white;
  border-radius: 10px;
  position: absolute;
  left: 35%;
  top: 30%;
}
.box_2 {
  height: 15%;
  width: 25%;
  background-color: white;
  border-radius: 10px;
  position: absolute;
  right: 2%;
  top: 60%;
}

.banner_box {
    height: 320px;
    width: 300px;
    background-color: #FFFFFF;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 1rem;
    color: rgb(48, 48, 48);
    margin: auto;
    /* gap: 6px; */
}
.banner_box:hover {
  background-color: #e5e7eb;
  transition: 500ms;
  color: black;
  cursor: pointer;
}
.home_card {
  height: calc(200vw / 6);
  width: calc(200vw / 6);
  border-radius: 51%;
  background-color: #ffb996;
  position: relative;
}
.card_circle {
  height: 50%;
  width: 55%;
  border-radius: 15px;
  background-color: #ffffff;
}
.card_banner {
  position: absolute;
  height: 84px;
  width: 253px;
  border-radius: 15px;
  background-color: white;
  top: 25%;
  left: 70%;
  box-shadow: 0px 0px 12px 1px rgba(0, 0, 0, 0.36);
}
.card_banner_2 {
  position: absolute;
  height: 84px;
  width: 253px;
  border-radius: 15px;
  background-color: white;
  top: 25%;
  right: 70%;
  box-shadow: 0px 0px 12px 1px rgba(0, 0, 0, 0.36);
}
.testimonials_parent {
  min-height: 30dvh;
  width: 100%;
  background-color: #ffb996;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* overflow: hidden; */
}

.black {
  background-color: #000000;
}

.test_star {
  height: 12%;
  width: 40%;
  border-radius: 8px;
  background-color: #000000;
}

.plan_card_client {
  height: 100%;
  width: 100%;
  border: 2px solid #ff5c09;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: black;
}

.plan_card_client_child {
  height: 100%;
  width: 80%;
  background-color: #ffebe0;
  border-radius: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding: 8px;
}

.plan_card_cook {
  border: 1px solid #ff5c09;
  border-radius: 15px;
  padding: 14px;
  display: flex;
  justify-content: left;
  align-items: left;
  flex-direction: column;
}

.progress_bar {
  height: 80px !important;
  width: 80px !important;
  padding: 8px;
}
.plan_card_mobile {
  background-color: #0c08ce;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: white;
  padding: 8px;
}
.progress_bar_left {
  height: 80px !important;
  width: 80px !important;
}

.post_job {
  padding: 32px 28px;
  border-radius: 15px;
  background-color: white;
}
a {
  text-decoration: none !important;
  color:#a020f0;
}

.bcrumb:hover {
  border-bottom: solid 1px #a020f0;
 
}
.help:hover {
  text-decoration: underline;
 
}

.cookLogin {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: auto;
  background-size: 100%;
  background-repeat: no-repeat;
}

.cookSignup {
  
  height: 80vh;
  background-repeat: no-repeat;
  background-size: contain;
}



input[type="switch"] {
  background-color: #000000;
}

.loginBox {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
eye_icon_login {
  position: absolute;
  top: 50%;
  right: 5%;
  transform: translate(-15%, -50%);
  transition: all 0.4s ease-in-out;
  font-size: 20px;
  color: black;
}

.eye_icon_login:hover {
  background-color: #dbdbdb;
  padding: 3px;
  font-size: 20px;
  border-radius: 50%;
}

input.input1::placeholder {
  color: #c4c4c4;
  
}
textarea.input1::placeholder
{
  color:#c4c4c4;
}

select {
  appearance: menulist !important;
}

.home-img {
  height: 40px;
  width: 40px;
}

.home-text {
  font-size: 16px;
}

.edit_button_profile {
  height: 6dvh;
  width: 100%;
  margin-top: 4dvh;
  margin-bottom: 3dvh;
  background-color: black;
  border: none;
  border-radius: 15px;
  font-size: 2.5dvh;
  font-weight: 600;
  text-transform: capitalize;
}
.edit_button_profile:hover {
  height: 6dvh;
  width: 100%;
  /* margin-top: 4dvh;
  margin-bottom: 3dvh; */
  border-radius: 15px;
  border: 2px solid #ff5c09;
  background-color: white;
  font-size: 2.5dvh;
  color: black;
  font-weight: 600;
}

.offcanvas {
  max-width: 80%;
}
.cards {
  border-radius: 15px;
  background-color: #ffffff;
}

/* .swiper-button-next,
.swiper-button-prev {
  background-image: url(./Assets//Images//next.png); */
/*background-repeat: no-repeat;
  background-size: contain;
  background-position: center; */
/* color: red !important;
 font-size: 50px !important;
 height: 4px !important;
 width: 4px !important;
} */

.swiper-button-next::after {
  /* border: 2px solid red;
  height: 50px !important;
  width: 50px !important;
  color: red !important; */
  font-size: 18px !important;
  color: #ff5c09;
  font-weight: 800 !important;


  /* background-image: url(./Assets/Images/next.png) !important; */
}
.swiper-button-prev::after {
  /* border: 2px solid red;
  height: 50px !important;
  width: 50px !important;
  color: red !important; */
  font-size: 18px !important;
  color: #ff5c09;
  font-weight: 800 !important;


  /* background-image: url(./Assets/Images/next.png) !important; */
}

.card
{
  border:none !important;
  border-radius: 10px;
}

.card-header
{
  border-top-right-radius: 10px !important;
  border-top-left-radius: 10px !important;
}




.label {
  font-weight:500;
  color:#989898;
}

.rdo {
  
  margin: 20px;
}



.rbt-token
{
color:#000 !important;
background-color:#f8ccb6 !important
}
.rbt
{
  border:none !important;
}

.cookSkills .rbt-token
{
color:#000 !important;
background-color:#f8ccb600 !important;
border: 1px gray solid;
border-radius: 40px;
}
.cookSkills .rbt
{
  border:none !important;
}

.form-control
{
  display: block;
    width: 100%;
    /* padding: 0.375rem 0.75rem; */
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    padding-top:-10px !important;
    /* color: var(--bs-body-color); */
    appearance: none;
    border: none !important;
    border-bottom: 1px solid #989898 !important;
    border-radius: 0 !important;
    transition: none !important;
}

.orange
{
  color:#ff5c09;
}

.text-heading
{
  color:#4b4a4a;
  font-size:14px;
}
.text-details
{
  color:#000000;
  margin-top:-15px;
  font-weight:500;
  text-wrap: wrap;
}

.label {
  font-weight:500;
  color:#989898;
}

.rbt-aux
{
  display:none !important;
}

.is-valid, .is-invalid
{
  background-image: none !important;
}
.form-check-input:checked
{
  background-color: #ff5c09;
  border-color: #ff5c09;

}

.switchButton
{
  margin-top:60px;
  margin-left:-130px;
}
.label1 {
  font-weight:500;
  color:#989898;
  margin-bottom: 10px;
}


.circle1,
.circle2 {
  background: white;
  background: linear-gradient(
      to right bottom,
      rgba(255, 255, 255, 0.9),
      rgba(255, 255, 255, 0.1)
  );
  height: 15rem;
  width: 15rem;
  position: absolute;
  border-radius: 50%;
}

.circle1 {
  top: 10%;
  left: 10%;
  transform: translate(-10%, -10%);
}

.circle2 {
  top: 90%;
  left: 40%;
  transform: translate(-50%, -50%);
}

::-webkit-scrollbar {
  width: 0;  /* Remove scrollbar space */
  background: transparent;  /* Optional: just make scrollbar invisible */
}
.flex-container
{
  width: auto;
  position: relative;
  overflow: auto;
  z-index: 1;
}
.navIcon
{
  height:17px;
  width:17px;
  margin-bottom: 3px;
}
.cancelBtn
{
  background-color: white !important;
  border: 1px solid #ff5c09 !important;
  color: #ff5c09;
  box-shadow: none;
  border-radius: 10px;
  width: 130px;
  height: 40px;

  font-size: 18px;
}

.cancelBtn:hover,
.cancelBtn:focus {
  height: 41px;
  width: 131px;
  background-color: white !important;
  border: 1px solid #ff5c09 !important;
  color: #ff5c09 !important;
  box-shadow: 0 0 5px #989898; /* Add appropriate box-shadow values */
}

.saveBtn
{
  background-color: #ff5c09 !important;
  border: 1px solid #fff !important;
  color: #fff;
  box-shadow: none;
  border-radius: 10px;
  width: 130px;
  height: 40px;
  font-size: 18px;
}


.notfoundbtn{
  background-color:blue !important;
  border: 1px solid #fff !important;
  color: #fff;
  box-shadow: none;
  border-radius: 10px;
  width:200px;
  height: 40px;
  font-size: 18px;
}

.saveBtn:hover {
  height: 41px ;
  width: 131px;
  background-color: #ff5c09 !important;
  box-shadow: #989898;
  border:none;

}

.apply_btn
{
  background-color: #ff5c09 !important;
  border: 1px solid #fff !important;
  color: #fff;
  box-shadow: none;
  border-radius: 10px;
  width: 100px;
  height: 40px;

  font-size: 18px;
}


.apply_btn:hover {
  height: 40px ;
  width: 100px;
  background-color: #ff5c09 !important;
  box-shadow: #989898;
  border:none;

}


.cancel_btn
{
  background-color: white !important;
  border: 1px solid #ff5c09 !important;
  color: #ff5c09;
  box-shadow: none;
  border-radius: 10px;
  width: 100px;
  height: 40px;
  font-size: 18px;
}
.cancel_btn:hover {
  height: 41px ;
  width: 101px;
  background-color: white !important;
  border: 1px solid #ff5c09 !important;
  color: #ff5c09 !important;
  box-shadow: #989898;

}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.homeCard{
border-radius: 10px;
background: white;
padding:12px 5px;
margin:5px;
box-shadow: 0 5px 15px rgba(145, 92, 182,0.2);
height:auto;
}
.homeCard:hover
{
  box-shadow: 0 5px 15px rgba(145, 92, 182, .4);
}
.detailCard
{
  width:49%;
}

@media (max-width: 767px) {

.detailCard
{
  width:98%;
}
}

.homeIcon
{
  height:24px;
  width:24px;
}
.contactCard{
  border-radius: 10px;
  background: white;
  padding:6px 10px;
  margin:5px;
  width:45px;
  box-shadow: 0 5px 15px rgba(145, 92, 182, .2);
  }
  .contactCard:hover{
    box-shadow: 0 5px 15px rgba(145, 92, 182, .4);
    }
td
{
  font-size: 14px;
}
.active>.page-link, .page-link.active
{
  background-color: #ff5c09;
  border: none;
}
.page-link
{
  color:#ff5c09
}
 .active
 {
  color:#ff5c09
 }
.multi-range-slider .ruler {
	margin: 10px 0px -5px 0px;
	/* display: flex; */
	display: none !important;
	overflow: hidden;
}
.cookjob
{
  width:32%;
}
.progress-bar
{
  background-color: #ff5c09;
  border-radius: 20px;
}
.modal-header
{
  border-bottom:none;
}

.modal-footer
{
  border-top:none;
  justify-content: flex-start;
}

input#session-date{
  position:relative;
  overflow:hidden;
}
input#session-date::-webkit-calendar-picker-indicator{
  display:block;
  top:0;
  left:0;
  background: #0000;
  position:absolute;
  transform: scale(12)
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active
{
  border-bottom: 3px solid #ff5c09;
 
  }
  .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #ff5c09;
      background-color: #fff;
      border-bottom: solid 3px #ff5c09 !important;
      border:none;
  }
  .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
    border-color : none;
  }

  .nav-link
  {
    color:#000;
  }

.plan-card {
  display: inline-block;
  /* Add any other styling for your column */
}

/* Media query for mobile view */
@media (max-width: 768px) {
  .plan-card {
    overflow-x: scroll;
  }
}
.container {
  overflow-x: auto;
  white-space: nowrap;
}


.planCard{

  padding:8px 20px;
  margin:5px;
  
  }

  .react-loading-skeleton
  {
    border-radius: 10px;
    background-color:#fff;
    --highlight-color:#fff;
    --base-color:#fafafa;
   
  }
  .dropdown-toggle::after{
   display:none;
}
.switch-handle {
  position: absolute;
 
  width: 28px;
  height: 28px;
  background: linear-gradient(to bottom, #FFFFFF 40%, #f0f0f0);
  background-image: -webkit-linear-gradient(top, #FFFFFF 40%, #f0f0f0);
  border-radius: 100%;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
}

.switch-handle2 {
  position: absolute;
 
  width: 28px;
  height: 28px;
  background: linear-gradient(to bottom, #ff5c09 40%, #f0d9cd);
  background-image: -webkit-linear-gradient(top, #ff5c09 40%, #f0d9cd);
  border-radius: 100%;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
}

.switch-handle:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -6px 0 0 -6px;
  width: 12px;
  height: 12px;
  background: linear-gradient(to bottom, #eeeeee, #FFFFFF);
  background-image: -webkit-linear-gradient(top, #eeeeee, #FFFFFF);
  border-radius: 6px;
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);
}
.switch-handle2:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -6px 0 0 -6px;
  width: 12px;
  height: 12px;
  background: linear-gradient(to bottom, #f0d9cd, #ff5c09);
  background-image: -webkit-linear-gradient(top, #f0d9cd, #ff5c09);
  border-radius: 6px;
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);
}

.switch-input:checked~.switch-handle {
  left: 84px;
  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
}

/* Transition
      ========================== */
.switch-label,
.switch-handle {
  transition: All 0.3s ease;
  -webkit-transition: All 0.3s ease;
  -moz-transition: All 0.3s ease;
  -o-transition: All 0.3s ease;
}

.swiper-3d .swiper-slide-shadow
{
  background:rgba(248,247,203,0.5) !important;
}


.modal-content {
 width:400px;
 max-height: auto;
  padding: 20px;
  text-align: left;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);
  color: #666;
  overflow-y: auto;
 
}
.select-no-border {
  border: none;
}

.modal-title
{
  margin-top: -20px;
  margin-left: -10px;
  
}
.swiper-pagination-bullet

{
  width:20px !important;
  border-radius: 10px !important;
} 

.swiper-pagination-bullet-active
{
  background: #ff5c09 !important;
}


/* .show{
  height: auto;
  } */
  .modal-backdrop.show
  {
    opacity: rgba(0,0,0,0.5);
  }

  .nav-link-item{
 
    padding: 8px;
    transition: all 0.3s ease-in-out;
    color:#000;
    font-weight: 500;
}
.invalid-feedback
{
  text-wrap: wrap ;
}
.text_container_child
{
  margin-top: 20%;
}






.rmsc .options {
  max-height: 260px;
  overflow-y: auto;
  z-index: 1001;
  margin: 0;
  position: relative;
  padding-left: 0;
}


.rmsc .options li {
  list-style: none;
  margin: 0;
  position: relative;
  z-index: 1001;

}
--------------



[data-rsbs-overlay] {
  border-top-left-radius: var(--rsbs-overlay-rounded);
  border-top-right-radius: var(--rsbs-overlay-rounded);
  display: flex;
  background: var(--rsbs-bg);
  flex-direction: column;
  height: var(--rsbs-overlay-h);
  transform: translate3d(0, var(--rsbs-overlay-translate-y), 0);
  will-change: height;
  background: #0c08ce;
}
[data-rsbs-overlay]:focus {
  outline: none;
}
[data-rsbs-is-blocking='false'] [data-rsbs-overlay] {
  box-shadow: 0 -5px 60px 0 rgba(38, 89, 115, 0.11),
    0 -1px 0 rgba(38, 89, 115, 0.05);
}
[data-rsbs-overlay],
[data-rsbs-root]:after {
  max-width: var(--rsbs-max-w);
  margin-left: var(--rsbs-ml);
  margin-right: var(--rsbs-mr);
}
[data-rsbs-overlay],
[data-rsbs-backdrop],
[data-rsbs-root]:after {
  z-index: 0;
  overscroll-behavior: none;
  touch-action: none;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}
[data-rsbs-backdrop] {
  top: -60px;
  bottom: -60px;
  background-color: var(--rsbs-backdrop-bg);
  will-change: opacity;
  cursor: pointer;
  opacity: 1;
}
[data-rsbs-is-dismissable='false'] [data-rsbs-backdrop] {
  cursor: ns-resize;
}

[data-rsbs-root]:after {
  content: '';
  pointer-events: none;
  background: var(--rsbs-bg);
  height: 1px;
  transform-origin: bottom;
  transform: scale3d(1, var(--rsbs-antigap-scale-y), 1);
  will-change: transform;
}
[data-rsbs-footer],
[data-rsbs-header] {
  flex-shrink: 0;
  cursor: ns-resize;
  padding: 16px;
}
[data-rsbs-header] {
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
  box-shadow: 0 1px 0
    rgba(46, 59, 66, calc(var(--rsbs-content-opacity) * 0.125));
  z-index: 0;
  padding-top: calc(20px + env(safe-area-inset-top));
  padding-bottom: 8px;
}
[data-rsbs-header]:before {
  position: absolute;
  content: '';
  display: block;
  width: 36px;
  height: 4px;
  top: calc(8px + env(safe-area-inset-top));
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px;
  background-color: var(--rsbs-handle-bg);
}
@media (min-resolution: 2dppx) {
  [data-rsbs-header]:before {
    transform: translateX(-50%) scaleY(0.75);
  }
}
[data-rsbs-has-header='false'] [data-rsbs-header] {
  box-shadow: none;
  padding-top: calc(12px + env(safe-area-inset-top));
}
[data-rsbs-scroll] {
  flex-shrink: 1;
  flex-grow: 1;
  -webkit-tap-highlight-color: revert;
  -webkit-touch-callout: revert;
  -webkit-user-select: auto;
  user-select: auto;
  overflow: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}
[data-rsbs-scroll]:focus {
  outline: none;
}
[data-rsbs-has-footer='false'] [data-rsbs-content] {
  padding-bottom: env(safe-area-inset-bottom);
}
[data-rsbs-content] {
  /* The overflow hidden is to ensure any margin on child nodes are included when the resize observer is measuring the height */
  overflow: hidden;
}
[data-rsbs-footer] {
  box-shadow: 0 -1px 0 rgba(46, 59, 66, calc(var(--rsbs-content-opacity) * 0.125)),
    0 2px 0 var(--rsbs-bg);
  overflow: hidden;
  z-index:-1;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
}

[data-rsbs-is-dismissable='true'],
[data-rsbs-is-dismissable='false']:matches([data-rsbs-state='opening'], [data-rsbs-state='closing']) {
  & :matches([data-rsbs-header], [data-rsbs-scroll], [data-rsbs-footer]) > * {
    opacity: var(--rsbs-content-opacity);
  }
  & [data-rsbs-backdrop] {
    opacity: var(--rsbs-backdrop-opacity);
  }
}

[data-rsbs-state='closed'],
[data-rsbs-state='closing'] {
  /* Allows interactions on the rest of the page before the close transition is finished */
  pointer-events: none;
}

[data-rsbs-overlay] {
  border-top-left-radius: var(--rsbs-overlay-rounded);
  border-top-right-radius: var(--rsbs-overlay-rounded);
  display: flex;
  background: var(--rsbs-bg);
  flex-direction: column;
  height: var(--rsbs-overlay-h);
  transform: translate3d(0, var(--rsbs-overlay-translate-y), 0);
  will-change: height;
}
[data-rsbs-overlay]:focus {
  outline: none;
}
[data-rsbs-is-blocking='false'] [data-rsbs-overlay] {
  box-shadow: 0 -5px 60px 0 rgba(38, 89, 115, 0.11),
    0 -1px 0 rgba(38, 89, 115, 0.05);
}
[data-rsbs-overlay],
[data-rsbs-root]:after {
  max-width: var(--rsbs-max-w);
  margin-left: var(--rsbs-ml);
  margin-right: var(--rsbs-mr);
}
[data-rsbs-overlay],
[data-rsbs-backdrop],
[data-rsbs-root]:after {
  z-index: -1;
  overscroll-behavior: none;
  touch-action: none;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}
[data-rsbs-backdrop] {
  top: -60px;
  bottom: -60px;
  background-color: var(--rsbs-backdrop-bg);
  will-change: opacity;
  cursor: pointer;
  opacity: 1;
}
[data-rsbs-is-dismissable='false'] [data-rsbs-backdrop] {
  cursor: ns-resize;
}

[data-rsbs-root]:after {
  content: '';
  pointer-events: none;
  background: var(--rsbs-bg);
  height: 1px;
  transform-origin: bottom;
  transform: scale3d(1, var(--rsbs-antigap-scale-y), 1);
  will-change: transform;
}
[data-rsbs-footer],
[data-rsbs-header] {
  flex-shrink: 0;
  cursor: ns-resize;
  padding: 16px;
}
[data-rsbs-header] {
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
  box-shadow: 0 1px 0
    rgba(46, 59, 66, calc(var(--rsbs-content-opacity) * 0.125));
  z-index: -1;
  padding-top: calc(20px + env(safe-area-inset-top));
  padding-bottom: 8px;
}
[data-rsbs-header]:before {
  position: absolute;
  content: '';
  display: block;
  width: 36px;
  height: 4px;
  top: calc(8px + env(safe-area-inset-top));
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px;
  background-color: var(--rsbs-handle-bg);
}
@media (min-resolution: 2dppx) {
  [data-rsbs-header]:before {
    transform: translateX(-50%) scaleY(0.75);
  }
}
[data-rsbs-has-header='false'] [data-rsbs-header] {
  box-shadow: none;
  padding-top: calc(12px + env(safe-area-inset-top));
}
[data-rsbs-scroll] {
  flex-shrink: 1;
  flex-grow: 1;
  -webkit-tap-highlight-color: revert;
  -webkit-touch-callout: revert;
  -webkit-user-select: auto;
  user-select: auto;
  overflow: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}
[data-rsbs-scroll]:focus {
  outline: none;
}
[data-rsbs-has-footer='false'] [data-rsbs-content] {
  padding-bottom: env(safe-area-inset-bottom);
}
[data-rsbs-content] {
  /* The overflow hidden is to ensure any margin on child nodes are included when the resize observer is measuring the height */
  overflow: hidden;
}
[data-rsbs-footer] {
  box-shadow: 0 -1px 0 rgba(46, 59, 66, calc(var(--rsbs-content-opacity) * 0.125)),
    0 2px 0 var(--rsbs-bg);
  overflow: hidden;
  z-index: -1;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
}

[data-rsbs-is-dismissable='true'],
[data-rsbs-is-dismissable='false']:matches([data-rsbs-state='opening'], [data-rsbs-state='closing']) {
  & :matches([data-rsbs-header], [data-rsbs-scroll], [data-rsbs-footer]) > * {
    opacity: var(--rsbs-content-opacity);
  }
  & [data-rsbs-backdrop] {
    opacity: var(--rsbs-backdrop-opacity);
  }
}

[data-rsbs-state='closed'],
[data-rsbs-state='closing'] {
  /* Allows interactions on the rest of the page before the close transition is finished */
  pointer-events: none;
}



/* Testimonial */

.carousel-root {
  width: 100% !important;
  margin: auto !important;
  margin-top: 3% !important;
}

.carousel .slide {
  background: #fff !important;
  color: black;
  height: 100%;
}

.carousel .slide img {
  width: 100px !important;
  height: 100px !important;
  border-radius: 50%;
}




.myCarousel h3 {
  color: #222;
  font-weight: 100;
  letter-spacing: 0.2px;
  margin-bottom: 4px;
  font-weight: 600;
 
  font-size: 17px;
}

.myCarousel h4 {

  margin-top: 0;
  padding-top: 0;
  font-weight: 500;
  color: #787878;
  font-size: 14px;
}

.myCarousel p {
  font-weight: 100 !important;
  line-height: 29px !important;
  color: #222;
  font-size: 15px;
  font-family: sans-serif;
  max-height: 67px;
}

.myCarousel p:before {
  content: "“";
  color: #aaa;
  font-size: 26px;
  font-family: monospace;
  font-weight: 100;
}

.myCarousel p:after {
  content: "”";
  color: #aaa;
  font-size: 26px;
  font-family: monospace;
  font-weight: 100;
  line-height: 0;
}

.carousel .control-dots .dot {
  box-shadow: none !important;
  background: #454545 !important;
  outline: 0;
}

.carousel.carousel-slider .control-arrow {
  background: #000 !important;
  height: 50px !important;
  position: absolute;
  top: 35% !important;
}

.App {
  text-align: center;
}

@media only screen and (min-width: 934px) {
  .carousel-root {
    outline: 0;
    width: 95% !important;
    margin: auto !important;
  }

  .carousel.carousel-slider .control-arrow {
    display: none !important;
  }
  .myCarousel {
    background: #fafafa;
    margin-top: -9%;
    width: 98%;
    margin-left: auto;
    margin-right: auto;
    padding-top: 8%;
    padding-bottom: 12.5%;
    padding-left: 5%;
    padding-right: 5%;
    border: 1px solid #ddd;
    height: 220px;
  }

  .carousel .slide img {
    width: 70px !important;
    height: 70px !important;
    border-radius: 50%;
  }
}

.carousel.carousel-slider .control-arrow
{
  display: none;
}


.btn-primary:hover
{
  background-color: #ff5c09 ;
  border:none;
}

.overviewcard
{
  width: 100%;
  height: 64px;
  background-color: white;
  display: flex;
  justify-content: flex-start;
  align-items:center;
  margin-top: 10px;
  padding: 10px;
  border-radius: 10px;
}

.overviewcardContact
{
  width: 100%;
  height: 20px;
  background-color: white;
  display: flex;

  padding: 10px 10px 10px 40px;

}

.overviewcircle{
 
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: #f4f4f4;
    display: flex;
    justify-content: center;
    align-items: center;
    

}

.overviewcircleContact{

    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:2px;
    margin-right: 5px;

}
@media (min-width: 767px) {
.contacticonCard{
  margin-top: -60px;
  align-content: end;
  justify-content: end;
}
}
@media (min-width: 767px) {
  .jobCard{
    margin-top: -20px;
    align-content: end;
  }
  }

  body {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}
footer{
    margin-top: auto;
}

.modalcancelBtn
{
  background-color: white !important;
  border: 1px solid #ff5c09 !important;
  color: #ff5c09 !important;
  box-shadow: none;
  border-radius: 10px;
  width: 80px;
  height: 35px;
  font-size: 14px;
}
.modalcancelBtn:hover {
  width: 81px;
  height: 36px;
  font-size: 14px;
  background-color: white !important;
  border: 1px solid #ff5c09 !important;
  color: #ff5c09 !important;
  box-shadow: #989898;

}

.modalsaveBtn
{
  background-color: #ff5c09 !important;
  border: 1px solid #ff5c09 !important;
  color: #fff;
  box-shadow: none;
  border-radius: 10px;
  width: 80px;
  height: 35px;
  font-size: 14px;
}
.modalsaveBtn:hover {
  width: 81px;
  height: 36px;
  font-size: 14px;
  background-color: #ff5c09 !important;
  border: 1px solid #ff5c09 !important;
  color: #fff;
  box-shadow: #989898;

}

.main-footer {
  width: 100%;
  z-index: 10;
  bottom: 0;
  padding: 0;
  border-top: 0;
}

.newTag
{
margin-top: -20px; 
margin-left: -28px;
}

@media (max-width: 767px) {
  .newTag
  {
  margin-top: -20px; 
  margin-left: -28px;
  }
  .filter{
    width:100%;
  }
}

@media (max-width: 920px) {
  .newTag
  {
  margin-top: -90px;  
  margin-left: -28px;
  }
  .filter{
    width:100%;
  }
}

@media (max-width: 480px) {
  .newTag
  {
  margin-top: -20px;  
  margin-left: -28px;
  }
  .filter{
    width:100%;
  }
}

.jobcancelBtn
{
  background-color: white !important;
  border: 1px solid #ff5c09 !important;
  color: #ff5c09;
  box-shadow: none;
  border-radius: 10px;
  width: 110px;
  height: 35px;
  font-size: 14px;
}
.jobcancelBtn:hover {
  width: 111px;
  height: 36px;
  font-size: 14px;
  background-color: white !important;
  border: 1px solid #ff5c09 !important;
  color: #ff5c09 !important;
  box-shadow: #989898;

}

.jobsaveBtn
{
  background-color: #ff5c09 !important;
  border: 1px solid #ff5c09 !important;
  color: #fff;
  box-shadow: none;
  border-radius: 10px;
  width: 110px;
  height: 35px;
  font-size: 14px;
}
.jobsaveBtn:hover {
  width: 111px;
  height: 36px;
  font-size: 14px;
  background-color: #ff5c09 !important;
  border: 1px solid #ff5c09 !important;
  color: #fff;
  box-shadow: #989898;

}

.editBtn{
  background-color: #ff5c09 !important;
  box-shadow: none;
  border-radius: 5px;
  font-size: 16px;
  border: none;
  width: 100px;
  height: 30px;
  color: white;

}
.editBtn:hover {
  height: 31px ;
  width: 101px;
  background-color: #ff5c09 !important;
  box-shadow: #989898;
  border:none;
  color: white;

}

.planBtn{
    padding: 0;
    margin: 0;
    height: 42px;
    width: 140px;
    background-color: #3D39D8 !important;
    border-radius: 36px;
    border: none;

}

.planBtn:hover{
 
  padding: 0;
  margin: 0;
  height: 45px;
  width: 150px;
  background-color: #3D39D8 !important;
  border-radius: 36px;
  border: none;

}

.editprofileBtn
{
  
    background-color: #000 !important;
    color: white !important;
    border-radius: 10px;
    box-shadow: none;
    border: none;
    width:110px;

}

.editprofileBtn:hover
{
  
    background-color: #000 !important;
    color: white !important;
    border-radius: 10px;
    box-shadow: none;
    border: none;
    width:111px;

}
@media (min-width: 921px) {
.filter{
  width:77%;
}
}

.newTagJob
{
margin-top: -25px; 
margin-left: -28px;
}

@media (max-width: 767px) {
  .newTagJob
  {
  margin-top: -25px; 
  margin-left: -28px;
  }

}

@media (max-width: 920px) {
  .newTagJob
  {
  margin-top: -25px;  
  margin-left: -28px;
  }

}

@media (max-width: 480px) {
  .newTagJob
  {
  margin-top: -42px;  
  margin-left: -28px;
  }

}

.newTagEvent
{
margin-top: -20px; 
margin-left: -28px;
}

@media (max-widh: 767px) {
  .newTagEvent
  {
  margin-top: -220px; 
  margin-left: -28px;
  }

}

@media (max-width: 920px) {
  .newTagEvent
  {
  margin-top: -20px;  
  margin-left: -28px;
  }

}

@media (max-width: 480px) {
  .newTagEvent
  {
  margin-top: -20px;  
  margin-left: -28px;
  }

}
.sidebar-menu-nav-title
{
  font-size: 16px;
}

.table-hover>tbody>tr:hover>* {
  background-color: #EFFFB2 ;
}

.table-hover tbody tr:hover {
  background-color : #EFFFB2;
}

.table-hover tbody tr
{
  height:50px;
  vertical-align: middle;
}

input[type="file"] {
  display: none;
}

/* Style the custom button */
.custom-button {
  display: inline-block;
  padding: 5px;
  border-radius:5px;
  background-color: #a020f0;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.custom-buttonProfile {
  display: inline-block;
  border-radius:150px;
  color:#ff5c09;
 background: #f2f2f2;
 padding-left: 5px;
  font-size: 16px;
  cursor: pointer;
  height:25px;
  width:25px;

  margin-left: 80px;
}

.downloadBtn
{
  border: solid 1px #ff5c09 !important;
  padding: 3px;
  border-radius: 5px;
  color: #ff5c09;
}

.tab-button {
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 10px 15px;
  font-size: 16px;
  margin-right: 10px;
  color: #000;
  border-bottom: 2px solid transparent;
}

.tab-button.disabled {
  opacity: 0.5;
  border-bottom-color: orangered;
  pointer-events: none;
}

.tab-button:hover {
  border-bottom-color: orangered; /* Change to desired hover color */
}


.downloadBtn:hover
{
  border: solid 1px #ff5c09 !important;
  padding: 4px;
  border-radius: 5px;
  color: #ff5c09;
}
.breadcrumb-container {
  background: #ff5c09;
  /* background: radial-gradient(circle, rgba(9,34,255,0.5) 57%, rgba(255,255,255,1) 100%); */
  width: 100%;
  height: 100px;
 
  color:#fff;
}
.breadcrumb-containerabout{
 
    background: #ff5c09;
    /* background: radial-gradient(circle, rgba(9,34,255,0.5) 57%, rgba(255,255,255,1) 100%); */
    width: 100%;
    height: 60px;
   
    color:#fff;
  }
.bottom-div {

  z-index: 9;
  margin-top: 150px;
  background-color: #fff;
}


.text-grad {
  background:radial-gradient(circle, #ff5c09 0%, #a020f0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.hero-sub-title {
  line-height: 1.2;
  display: inline-block;
  color: #a020f0;
  font-size: 1.75rem;
  
}

.overviewcardAbout
{
  width: 95%;
  height: auto;
  background-color: #fbfbfb;
  display: flex;
  justify-content: flex-start;
  align-items:center;
  margin-top: 10px;
  padding: 15px ;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(145, 92, 182,0.2);
}

select
{
    color: #000;
}
option
{
    color: #000;
}
option:first-child
{
    color: #000;
}
/* .pagination li:last-child {
  display: none;
} */

.myCarousel1 {
  background: #f3f8ff;
  margin-top: -12%;
  width: 98%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 6%;
  padding-bottom: 8%;
  padding-left: 5%;
  padding-right: 5%;
  border: 1px solid #ddd;
  height: 17dvh;
  border-radius: 10px;
}

.cookCard{
  border-radius: 10px;
  background: #f9f9f9;
  padding:12px 5px;
  margin:5px;


  }
  .cookCard:hover
  {
    box-shadow: 0 5px 15px rgba(145, 92, 182, .4);
  }

  .webBtn1
  {
    background-color: rgba(255, 92, 9,0.9) !important;
    border:none;
    box-shadow: none;
    text-transform: capitalize;
    color: #fff;
    height: 42px;
    width: 120px;
    font-size: 1em;
    padding: 0px 20px;
    border-radius: 15px;
  }

  .webBtn1:hover
  {
    background-color: rgb(255, 92, 9) !important;
    border: solid 3px rgb(255, 92, 9) !important;
  }

  .webBtn2
  {
    background-color: #fff;
    border:solid 1px rgba(255, 92, 9,0.9) !important;
    box-shadow: none;
    text-transform: capitalize;
    color: #ff5c09;
    height: 42px;
    width: 120px;
    font-size: 1em;
    padding: 0px 20px;
    border-radius: 15px;
  }

  .webBtn2:hover
  {
    background-color: rgba(255, 92, 9,0.9) !important;
    border: none;
    color:#fff;
  }

  .profileBtn {
    height: 42px;
    width: 120px;
    padding: 0;
    margin-top: 5px;
    text-align: center;
    font-size: 16px;
    border: none;
    background: rgba(255, 92, 9,0.9) !important;
    border-radius: 14px;
  }



  .profileBtn:hover
  {
    background: #ff5c09 !important;
  }

  ::-ms-reveal {
    display: none;
}


.btn-primary:hover {
  background-color : none;
  border-color : none;
}
.btn-primary:focus, .btn-primary.focus {
  box-shadow : 0 0 0 0.2rem rgba(102, 110, 232, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color : #FFFFFF;
  background-color : #ff5c09;
  border-color : #ff5c09;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color : #fff;
  background-color : #fff;
  border-color : #fff;
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow : 0 0 0 0.2rem rgba(102, 110, 232, 0.5);
}


.sticky-container {
  position: fixed;
  bottom: 20px; /* Adjust as needed */
  left: 0;
  width: 100%;
  z-index: 1000; /* Ensure it's above other content */
}

.sticky-div {
  background-color: #333;
  color: white;
  padding: 10px;
  text-align: left;
}

.download-button {
  padding: 10px 20px;
  background-color: #0077B5;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.close-button {
  padding: 10px 20px;
  background-color: #fff;
  color: #000;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.download-button:hover {
  background-color: #005580;
}

.content {
  padding: 20px;
  /* Add some space at the bottom to prevent content from being hidden under the sticky div */
  margin-bottom: 60px; /* Adjust according to the height of the sticky div */
}

.section-bg {
  background: #fff9f1;
}
@media (min-width: 992px) {
  .padding-tb {
      padding: 110px 0;
  }
}
@media (min-width: 1200px) {
  .four-zero-section .four-zero-content .title {
      font-size: 100px;
      line-height: 1;
  }
}

.lab-btn {
  padding: 10px 30px;
  background: #ff5c09;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 700;
  color:#fff
}
.tablecontainer{
  background-color: white;
  align-items: center;
}

.table-custom {
  border-collapse: separate;
  border-spacing: 0;
  padding: 40px;
}

.table-custom thead th {
  border-bottom: 2px solid black;
  /* Black line after the heading */
}

.borderBt-tr {
  border-bottom: 2px solid black; 
  height: 100px !important;
}

.vertical-middle {
  vertical-align: middle !important;
}

.view_btn
{
  background-color: #ff5c09 !important;
  border: 1px solid #fff !important;
  color: #fff;
  box-shadow: none;
  border-radius: 10px;
  width: auto;
  /* height: 40px; */
  font-size: 16px;
}


.view_btn:hover {
  /* height: 40px ; */
  width: auto;
  background-color: #ff5c09 !important;
  box-shadow: #989898;
  border:none;

}

.perks .item {
  background-color: #F2F2F2;
  padding: 20px;
  padding: 10px 15px;
  border-radius: 30px;
  margin-right: 20px;
  font-weight: 400;
  cursor: pointer;
}

.perks .item-false {
  background-color: #F2F2F2;
  border: 1px solid  rgb(255, 92, 9);
  padding: 10px 15px;
  border-radius: 30px;
  color: rgb(255, 92, 9);
  margin-right: 20px;
  font-weight: 400;
  cursor: pointer;
}

.perks .item-job {
  background-color: #F2F2F2;
  border: 1px solid rgb(255, 92, 9);
  padding: 5px 5px;
  border-radius: 30px;
  color: rgb(255, 92, 9);
  font-weight: 400;
  font-size: 14px;
  display: flex;
  margin-bottom: 10px;
  justify-content: center;
  cursor: pointer;
}

.perks .item-ejob {
  background-color: #F2F2F2;
  border: 1px solid rgb(255, 92, 9);
  padding: 5px 5px;
  border-radius: 30px;
  color: rgb(255, 92, 9);
  font-weight: 400;
  font-size: 12px;
  display: flex;
  margin-bottom: 10px;
  justify-content: center;
  cursor: pointer;
}

.perks .item-false .icon {
  color: rgb(255, 92, 9);
  font-size: 25px;
}

.perks .item-job .icon {
  color: rgb(255, 92, 9);
  font-size: 20px;
  display: flex;
  align-items: center;
}

.perks .item .icon {
  font-size: 25px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA,yBAAyB;;AAEzB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,2CAA2C;EAC3C,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;;;IAGE,WAAW;IACX,UAAU;EACZ;EACA;;IAEE,WAAW;IACX,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,wBAAwB;EAC1B;;;EAGA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,QAAQ;IACR,eAAe;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;AACA;EACE;;;EAGA,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;EACE;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;EACf;;;AAGF;AACA;AACA;EACE,SAAS;AACX;AACA;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;;AAGA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;;AAGA;IACI,wBAAwB;IACxB,aAAa;IACb,qBAAqB;AACzB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,2CAA2C;EAC3C,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;;EAEb,wCAAwC;AAC1C;;;AAGA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;AACA;EACE,wBAAwB;EACxB,2CAA2C;AAC7C;;;;AAIA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;;;AAIA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;AACA;;;;;;;GAOG;;AAEH;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,cAAc;EACd,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iDAAiD;;AAEnD;;;AAGA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;;AAE1B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;;;AAGnB;;;AAGA;EACE,cAAc;EACd,wBAAwB;AAC1B;;;;AAIA;EACE,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;AACZ,WAAW;AACX;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ,WAAW;AACX;AACA;AACA,OAAO,oBAAoB;AAC3B;AACA;;AAEA;EACE;EACA,oBAAoB;EACpB;EACA;AACF;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;EACX,WAAW;EACX;;;EAGA;IACE,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;EACX,WAAW;EACX;;AAEF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;EACX,WAAW;EACX;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;EACX,WAAW;EACX;;AAEF;;AAEA;;EAEE;IACE,oBAAoB;IACpB;KACC;EAKH,2BAA2B;;;EAG3B;AACF;;;AAGA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,qCAAqC;EACrC,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,qCAAqC;EACrC,wBAAwB;EACxB,oCAAoC;AACtC;AACA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,qCAAqC;EACrC,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;;EAE3B,YAAY;AACd;;AAEA;EACE,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,cAAc;AAClB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,gDAAgD;AAClD;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,gDAAgD;AAClD;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,gCAAgC;;AAElC;AACA;EACE,0BAA0B;;AAE5B;;AAEA;EACE,yDAA4D;EAC5D,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;AAC1B;;;;AAIA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4EAA4E;AAC9E;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;;AAEhB;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,WAAW;EACX;wBACsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;sDAEsD;AACtD;;gCAEgC;AAChC;;;;GAIG;;AAEH;EACE;;;0BAGwB;EACxB,0BAA0B;EAC1B,cAAc;EACd,2BAA2B;;;EAG3B,gEAAgE;AAClE;AACA;EACE;;;0BAGwB;EACxB,0BAA0B;EAC1B,cAAc;EACd,2BAA2B;;;EAG3B,gEAAgE;AAClE;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,wCAAwC;EACxC,uCAAuC;AACzC;;;;;AAKA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,YAAY;AACd;;;;AAIA;;AAEA,qBAAqB;AACrB;AACA;AACA;;EAEE,sBAAsB;AACxB;;AAEA;;AAEA,qBAAqB;AACrB,qCAAqC;AACrC,sBAAsB;AACtB,mBAAmB;AACnB;AACA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;IACZ,WAAW;IACX,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,iCAAiC;IACjC,gBAAgB;IAChB,uBAAuB;IACvB,2CAA2C;IAC3C,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;;AAEvB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;;AAGA;;EAEE,iBAAiB;EACjB;;;;GAIC;EACD,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,QAAQ,GAAG,2BAA2B;EACtC,uBAAuB,GAAG,4CAA4C;AACxE;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;AACA;;EAEE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;;EAEZ,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B,EAAE,sCAAsC;AACrE;;AAEA;;EAEE,oCAAoC;EACpC,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;;AAEb;;AAEA;;EAEE,oCAAoC;EACpC,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;;EAEZ,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;;AAEb;;;AAGA;;EAEE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,kCAAkC;EAClC,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;;AAErB;;;AAGA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;AACA,mBAAmB;AACnB,iBAAiB;AACjB,gBAAgB;AAChB,UAAU;AACV,6CAA6C;AAC7C,WAAW;AACX;AACA;;EAEE,6CAA6C;AAC/C;AACA;;EAEE,SAAS;AACX;;AAEA;;AAEA;;EAEE,SAAS;AACX;AACA;;AAEA;;EAEE,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,6CAA6C;EAC7C;EACA;IACE,6CAA6C;IAC7C;AACJ;;EAEE,eAAe;AACjB;AACA;;EAEE,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE;AACF;CACC;;EAEC;CACD;AACD;CACC,yBAAyB;CACzB,mBAAmB;CACnB,wBAAwB;CACxB,gBAAgB;AACjB;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,KAAK;EACL,MAAM;EACN,iBAAiB;EACjB,iBAAiB;EACjB;AACF;;AAEA;;EAEE,gCAAgC;;EAEhC;EACA;IACE,cAAc;MACZ,sBAAsB;MACtB,2CAA2C;MAC3C,WAAW;EACf;EACA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,UAAU;EACZ;;AAEF;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,gCAAgC;AAChC;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;;EAEE,gBAAgB;EAChB,UAAU;;EAEV;;EAEA;;IAEE,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;;EAEtB;EACA;GACC,YAAY;AACf;AACA;EACE,kBAAkB;;EAElB,WAAW;EACX,YAAY;EACZ,4DAA4D;EAC5D,oEAAoE;EACpE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,YAAY;EACZ,4DAA4D;EAC5D,oEAAoE;EACpE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,wDAAwD;EACxD,gEAAgE;EAChE,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,wDAAwD;EACxD,gEAAgE;EAChE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,2CAA2C;AAC7C;;AAEA;kCACkC;AAClC;;EAEE,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;;EAEE,2CAA2C;AAC7C;;;AAGA;CACC,WAAW;CACX,gBAAgB;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;;AAElB;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;;AAEpB;AACA;;;EAGE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;;AAGA;;KAEK;EACH;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,YAAY;IACZ,gCAAgC;IAChC,UAAU;IACV,gBAAgB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,eAAe;AACjB;;;;;;;AAOA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,aAAa;;AAEf;AACA;;;;;EAKE,mDAAmD;EACnD,oDAAoD;EACpD,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,6DAA6D;EAC7D,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE;oCACkC;AACpC;AACA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;;;EAGE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;EACxC,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,aAAa;EACb,yCAAyC;EACzC,oBAAoB;EACpB,eAAe;EACf,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,wBAAwB;EACxB,qDAAqD;EACrD,sBAAsB;AACxB;AACA;;EAEE,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB;+DAC6D;EAC7D,UAAU;EACV,kDAAkD;EAClD,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE;IACE,wCAAwC;EAC1C;AACF;AACA;EACE,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,cAAc;EACd,YAAY;EACZ,mCAAmC;EACnC,6BAA6B;EAC7B,yBAAyB;EAEzB,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,iCAAiC;AACnC;AACA;EACE,aAAa;AACf;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,6HAA6H;EAC7H,gBAAgB;AAClB;AACA;EACE;0BACwB;EACxB,gBAAgB;EAChB,UAAU;EACV,wDAAwD;AAC1D;;AAEA;;EAEE;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;;EAEE,wFAAwF;EACxF,oBAAoB;AACtB;;AAEA;EACE,mDAAmD;EACnD,oDAAoD;EACpD,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,6DAA6D;EAC7D,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE;oCACkC;AACpC;AACA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;EACxC,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,aAAa;EACb,yCAAyC;EACzC,oBAAoB;EACpB,eAAe;EACf,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,wBAAwB;EACxB,qDAAqD;EACrD,sBAAsB;AACxB;AACA;;EAEE,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB;+DAC6D;EAC7D,WAAW;EACX,kDAAkD;EAClD,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE;IACE,wCAAwC;EAC1C;AACF;AACA;EACE,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,cAAc;EACd,YAAY;EACZ,mCAAmC;EACnC,6BAA6B;EAC7B,yBAAyB;EAEzB,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,iCAAiC;AACnC;AACA;EACE,aAAa;AACf;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,6HAA6H;EAC7H,gBAAgB;AAClB;AACA;EACE;0BACwB;EACxB,gBAAgB;EAChB,WAAW;EACX,wDAAwD;AAC1D;;AAEA;;EAEE;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;;EAEE,wFAAwF;EACxF,oBAAoB;AACtB;;;;AAIA,gBAAgB;;AAEhB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;AACpB;;;;;AAKA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;;EAEhB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;;EAEE,aAAa;AACf;;;AAGA;;EAEE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;;EAEb,4BAA4B;;AAE9B;;AAEA;;IAEI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;;AAGvB;;AAEA;;IAEI,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;;AAErB;AACA;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;;AAEA;;EAEE,kCAAkC;EAClC,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;;AAErB;;AAEA;;EAEE,oCAAoC;EACpC,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,oCAAoC;EACpC,WAAW;EACX,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA;;AAEA,iBAAiB;AACjB,kBAAkB;AAClB;;AAEA;EACE;;EAEA,iBAAiB;EACjB,kBAAkB;EAClB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;EAEA,iBAAiB;EACjB,kBAAkB;EAClB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;EAEA,iBAAiB;EACjB,kBAAkB;EAClB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;;AAErB;;AAEA;;EAEE,oCAAoC;EACpC,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,oCAAoC;EACpC,WAAW;EACX,mBAAmB;;AAErB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;;AAEd;AACA;EACE,aAAa;EACb,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,YAAY;;AAEd;;AAEA;IACI,UAAU;IACV,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;;AAEhB;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;;AAEd;;AAEA;;;IAGI,iCAAiC;IACjC,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,WAAW;;AAEf;;AAEA;;;IAGI,iCAAiC;IACjC,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,WAAW;;AAEf;AACA;AACA;EACE,SAAS;AACX;AACA;;AAEA;;AAEA,iBAAiB;AACjB,kBAAkB;AAClB;;AAEA;EACE;;EAEA,iBAAiB;EACjB,kBAAkB;EAClB;;AAEF;;AAEA;EACE;;EAEA,iBAAiB;EACjB,kBAAkB;EAClB;;AAEF;;AAEA;EACE;;EAEA,iBAAiB;EACjB,kBAAkB;EAClB;;AAEF;;AAEA;;AAEA,iBAAiB;AACjB,kBAAkB;AAClB;;AAEA;EACE;;EAEA,kBAAkB;EAClB,kBAAkB;EAClB;;AAEF;;AAEA;EACE;;EAEA,iBAAiB;EACjB,kBAAkB;EAClB;;AAEF;;AAEA;EACE;;EAEA,iBAAiB;EACjB,kBAAkB;EAClB;;AAEF;AACA;;EAEE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;CACd,mBAAmB;CACnB,iBAAiB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;;EAEV,iBAAiB;AACnB;;AAEA;;EAEE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B,EAAE,kCAAkC;AACpE;;;AAGA;;EAEE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,2FAA2F;EAC3F,WAAW;EACX,aAAa;;EAEb,UAAU;AACZ;AACA;;IAEI,mBAAmB;IACnB,2FAA2F;IAC3F,WAAW;IACX,YAAY;;IAEZ,UAAU;EACZ;AACF;;EAEE,UAAU;EACV,iBAAiB;EACjB,sBAAsB;AACxB;;;AAGA;EACE,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;;AAEpB;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;;IAEI,WAAW;AACf;AACA;;IAEI,WAAW;AACf;AACA;;IAEI,WAAW;AACf;AACA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;;;EAGV;EACA;;IAEE,6CAA6C;EAC/C;;EAEA;;IAEE,iDAAiD;IACjD,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,4CAA4C;IAC5C,4CAA4C;EAC9C;;EAEA;;IAEE,sBAAsB;IACtB,gDAAgD;IAChD,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,iDAAiD;IACjD,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,2CAA2C;IAC3C,mBAAmB;EACrB;;;;EAIA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,aAAa;AACjB;;;AAGA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EAEU,kDAAkD;AAC5D;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EAEU,kDAAkD;AAC5D;;;AAGA;EACE,eAAe;EACf,YAAY,EAAE,qBAAqB;EACnC,OAAO;EACP,WAAW;EACX,aAAa,EAAE,oCAAoC;AACrD;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2FAA2F;EAC3F,mBAAmB,EAAE,qDAAqD;AAC5E;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;MACI,gBAAgB;EACpB;AACF;AACA;EACE;MACI,gBAAgB;MAChB,cAAc;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;AACF;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,oCAAoC;EACpC,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;;AAEb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["body {\n  display: flex;\n  flex-direction: column;\n}\n\n.route-loading {\n  min-height: 40vh;\n  display: grid;\n  place-items: center;\n  padding: 2rem;\n  color: #4b5563;\n  font-size: 0.95rem;\n}\n/* customDatepicker.css */\n\n.inputdate1 {\n  padding: 0 !important;\n  margin: 0 !important;\n  border: none !important;\n  border-bottom: 1px solid #989898 !important;\n  border-radius: 0 !important;\n  margin-bottom: 20px;\n  outline: none;\n  background-color: transparent !important;\n}\n\n.table-expanded-row {\n  display: flex;\n  justify-content: space-around;\n  text-align: center;\n}\n\n.show-mobile{\n  display: none;\n}\n\n.plan-history-filter-container{\n  display: flex;\n  background-color: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin: auto;\n  padding:20px;\n  border-radius: 10px;\n}\n\n@media (max-width: 767px) {\n  .cprogress\n\n  {\n    height:90px;\n    width:90px;\n  }\n  .userdp\n  {\n    height:80px;\n    width:80px;\n    border-radius: 120px;\n  }\n  .web_nav {\n    display: none !important;\n  }\n  \n\n  .myCarousel {\n    background: #fafafa;\n    margin-top: -12%;\n    width: 98%;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 6%;\n    padding-bottom: 8%;\n    padding-left: 5%;\n    padding-right: 5%;\n    border: 1px solid #ddd;\n    height: 230px;\n  }\n  .hide-mobile {\n    display: none;\n  }\n  .table-cell {\n    padding: 7px !important;\n    font-size: small;\n  }\n  .table-arrow{\n    width: 15px;\n  }\n  .table-expanded-row{\n    gap: 5px;\n    flex-wrap: wrap;\n  }\n  .table-expanded-row > * {\n    flex: 0 0 45%;\n    box-sizing: border-box;\n  }\n  .show-mobile{\n    display: block;\n  }\n  .plan-history-filter-container{\n    justify-content: center;\n    /* width: 350px; */\n  }\n}\n@media (min-width: 767px) {\n  .cprogress\n\n{\n  height:115px;\n  width:115px;\n}\n.userdp\n{\n  height:100px;\n  width:100px;\n  border-radius: 120px;\n}\n  .mob_nav {\n    display: none;\n  }\n  .myCarousel {\n    background: #fafafa;\n    margin-top: -12%;\n    width: 98%;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 6%;\n    padding-bottom: 8%;\n    padding-left: 5%;\n    padding-right: 5%;\n    border: 1px solid #ddd;\n    height: 35dvh;\n  }\n  \n \n}\n@media (max-width: 1180px) {\n.dashbar{\n  width:22%;\n}\n}\n@media (max-width: 768px) {\n  .filter_parent {\n    display: none !important;\n  }\n}\n\n\n.pac-container {\n  z-index:1000 !important;\n  position: absolute;\n}\n\n\n.checkout-con-1{\n    /* outline: red solid; */\n    display: flex;\n    align-content: center;\n}\n\n@media (max-width: 767px) {\n  .filter_parent_application {\n    display: none !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .hide_img {\n    display: none !important;\n  }\n  .checkout-con-1{\n    flex-direction: column;\n    padding: 10px;\n  }\n}\n@media (min-width: 920px) {\n  .display_img {\n    display: none !important;\n  }\n}\n\n:root {\n  margin: 0;\n  padding: 0;\n}\n.input1 {\n  padding: 0 !important;\n  margin: 0 !important;\n  border: none !important;\n  border-bottom: 1px solid #989898 !important;\n  border-radius: 0 !important;\n  margin-bottom: 20px;\n  outline: none;\n\n  background-color: transparent !important;\n}\n\n\n.input1:focus {\n  box-shadow: none !important;\n  border-bottom: 1px solid #ff5c09 !important;\n}\n.input1:hover {\n  outline: none !important;\n  border-bottom: 1px solid #ff5c09 !important;\n}\n\n\n\n.forgot_password {\n  color: #ff5c09;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n\n\n.nav_login {\n  background-color: #ff5c09;\n  border: none;\n  border-radius: 8px;\n  color: #ffffff !important;\n  padding: 8px 20px;\n  width:150px;\n}\n/* .nav_login:hover {\n  background-color: white;\n  border: 2px solid #3352D0;\n  border-radius: 8px;\n  color: #000000;\n  padding: 8px 20px;\n  transition: 500ms;\n} */\n\n.nav_cook_login {\n  background-color: #00b0a0;\n  border: none;\n  border-radius: 8px;\n  color: #000000;\n  padding: 8px 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.nav_cook_login:hover {\n  background-color: white;\n  border: 2px solid #00b0a0;\n  border-radius: 8px;\n  color: #000000;\n  padding: 8px 20px;\n  transition: 500ms;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.signup_btn {\n  border: 2px solid #ff5c09 !important;\n  border-radius: 8px;\n  color: #ff5c09;\n  padding: 8px 20px;\n}\n.signup_btn:hover {\n  background-color: #ff5c09 !important;\n  border: none;\n  border-radius: 8px;\n  color: white;\n  padding: 8px 20px;\n  transition: 800ms;\n}\n.terms_and_conditions {\n  color: #ff5c09;\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 12px;\n  text-wrap: wrap;\n}\n.toggle_button {\n  color: #ff5c09;\n  border: 2px solid #ff5c09;\n  border-radius: 8px;\n  padding: 8px 20px;\n  background-color: white;\n}\n.toggle_button:hover {\n  background-color: #ff5c09;\n  color: white;\n  transition: 500ms;\n}\n.toggle_button_active {\n  border-radius: 8px;\n  border: none;\n  padding: 8px 20px;\n  background-color: #ff5c09;\n  color: white;\n}\n\n.login_btn {\n  height: 48px !important;\n  width: 200px !important;\n  border-radius: 50px !important;\n  background-color: #ff5c09 !important;\n  color: #ffffff;\n  border-radius: 15px !important;\n  border: none !important;\n  font-size: 18px;\n}\n.sidebar {\n  /* height: 600px; */\n  padding: 14px;\n  width: \"100%\";\n  background-color: white;\n  border-radius: 15px;\n  box-shadow: 0px 0px 17px -1px rgba(0, 0, 0, 0.16);\n\n}\n\n\n.sidebar-menu-body {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  padding: 8px 8px 8px 0px;\n\n}\n\n.sidebar-menu-nav {\n  height: 30px;\n  width: 230px;\n  padding: 5px 5px;\n  /* border-bottom: solid 1px #e6e3e3; */\n  display: flex;\n  justify-content: flex-start;\n  align-items: left;\n  cursor: pointer;\n  margin-left: -19px;\n  transition: 500ms;\n\n  \n}\n\n\n.sidebar-menu-nav-link {\n  color: #000000;\n  padding:5px 5px 5px 20px;\n}\n\n\n\n.sidebar-menu-nav .active-link {\n  color:#fff;\n  background:#ff5c09;\n  padding:5px 5px 5px 20px;\n  width:100%;\nheight:34px;\n}\n.sidebar-menu-nav .active-links {\n  color:#fff;\n  background:#ff5c09;\n  padding:5px 10px 5px 10px;\n  width:100%;\nheight:34px;\n}\n@media only screen and (max-width: 767px) {\n.arrow{justify-content: end;\n}\n}\n\n@media only screen and (min-width: 768px) {\n  .arrow{\n  justify-content: end;\n  }\n  }\n@media screen and (min-width: 1200px) {\n  .sidebar-menu-nav .active-link {\n    color:#fff;\n    background:#ff5c09;\n    padding:5px 5px 5px 20px;\n    width:94%;\n  height:34px;\n  }\n  \n\n  .sidebar-menu-nav .active-links {\n    color:#fff;\n    background:#ff5c09;\n    padding:5px 10px 5px 10px;\n    width:94%;\n  height:34px;\n  }\n \n}\n\n@media only screen and (min-width: 1024px) and (max-width: 1199px) {\n  .sidebar-menu-nav .active-link {\n    color:#fff;\n    background:#ff5c09;\n    padding:5px 5px 5px 20px;\n    width:65%;\n  height:34px;\n  }\n  .sidebar-menu-nav .active-links {\n    color:#fff;\n    background:#ff5c09;\n    padding:5px 10px 5px 10px;\n    width:65%;\n  height:34px;\n  }\n  \n}\n\n.sidebar-menu-nav:hover {\n \n  .sidebar-menu-nav-link {\n    /* color: #ff5c09; */\n    /* border-radius: 10px;\n    */\n  -webkit-transition: color 0.8s ease;\n  -moz-transition: color 0.8s ease;\n  -ms-transition: color 0.8s ease;\n  -o-transition: color 0.8s ease;\n  transition: color 0.8s ease;\n  \n\n  }\n}\n\n\n.sidebar-menu-sub {\n  width: 300px;\n  padding: 5px 5px;\n}\n\n.sidebar-menu-sub-toggle {\n  border: none;\n  background-color: transparent;\n}\n\n.dash_card {\n  height: auto;\n  width: 100%;\n  background-color: white;\n  border-radius: 15px;\n  padding: 10px;\n}\n\n.navMenu {\n  color: #000000 !important;\n  font-weight: 400;\n}\n.search_parent {\n  padding: 4px;\n  border-radius: 15px;\n  border: 2px solid #9e9e9e;\n}\n.search_parent:hover {\n  border: 2px solid #ff5c09;\n}\n.search_parent:focus {\n  border: 2px solid #ff5c09;\n}\n.search {\n  border: none !important;\n  border-radius: 30px !important;\n  background-color: transparent !important;\n}\n.search:focus {\n  box-shadow: none !important;\n}\n\n.view_profile {\n  background-color: #fff !important;\n  height: 25px;\n  width: 75px;\n  box-shadow: none !important;\n  border-radius: 5px !important;\n  font-size: 12px !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  text-transform: capitalize !important;\n  color:#ff5c09;\n  padding:5px;\n  border: solid 1px #ff5c09;\n}\n.view_profile:hover {\n  background-color: #fff !important;\n  height: 26px;\n  width: 76px;\n  padding:5px;\n  box-shadow: none !important;\n  border-radius: 5px !important;\n  font-size: 12px !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  text-transform: capitalize !important;\n  color:#ff5c09 !important;\n  border: solid 1px #ff5c09 !important;\n}\n.filter_btn {\n  background-color: transparent !important ;\n  color: #ff5c09 !important;\n  text-transform: capitalize !important;\n  box-shadow: none !important;\n  padding:8px;\n  margin-bottom: 10px;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n \n  border: none;\n}\n\n.banner_child {\n  width: 40%;\n  min-height: 75%;\n  background-color: #ff5c09;\n  border-radius: 50%;\n  position: absolute;\n  bottom: 5%;\n  right: 10%;\n}\n.box {\n  height: 15%;\n  width: 25%;\n  background-color: white;\n  border-radius: 10px;\n  position: absolute;\n  left: 35%;\n  top: 30%;\n}\n.box_2 {\n  height: 15%;\n  width: 25%;\n  background-color: white;\n  border-radius: 10px;\n  position: absolute;\n  right: 2%;\n  top: 60%;\n}\n\n.banner_box {\n    height: 320px;\n    width: 300px;\n    background-color: #FFFFFF;\n    border-radius: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    padding: 1rem;\n    color: rgb(48, 48, 48);\n    margin: auto;\n    /* gap: 6px; */\n}\n.banner_box:hover {\n  background-color: #e5e7eb;\n  transition: 500ms;\n  color: black;\n  cursor: pointer;\n}\n.home_card {\n  height: calc(200vw / 6);\n  width: calc(200vw / 6);\n  border-radius: 51%;\n  background-color: #ffb996;\n  position: relative;\n}\n.card_circle {\n  height: 50%;\n  width: 55%;\n  border-radius: 15px;\n  background-color: #ffffff;\n}\n.card_banner {\n  position: absolute;\n  height: 84px;\n  width: 253px;\n  border-radius: 15px;\n  background-color: white;\n  top: 25%;\n  left: 70%;\n  box-shadow: 0px 0px 12px 1px rgba(0, 0, 0, 0.36);\n}\n.card_banner_2 {\n  position: absolute;\n  height: 84px;\n  width: 253px;\n  border-radius: 15px;\n  background-color: white;\n  top: 25%;\n  right: 70%;\n  box-shadow: 0px 0px 12px 1px rgba(0, 0, 0, 0.36);\n}\n.testimonials_parent {\n  min-height: 30dvh;\n  width: 100%;\n  background-color: #ffb996;\n  border-radius: 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* overflow: hidden; */\n}\n\n.black {\n  background-color: #000000;\n}\n\n.test_star {\n  height: 12%;\n  width: 40%;\n  border-radius: 8px;\n  background-color: #000000;\n}\n\n.plan_card_client {\n  height: 100%;\n  width: 100%;\n  border: 2px solid #ff5c09;\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: black;\n}\n\n.plan_card_client_child {\n  height: 100%;\n  width: 80%;\n  background-color: #ffebe0;\n  border-radius: 15px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: column;\n  padding: 8px;\n}\n\n.plan_card_cook {\n  border: 1px solid #ff5c09;\n  border-radius: 15px;\n  padding: 14px;\n  display: flex;\n  justify-content: left;\n  align-items: left;\n  flex-direction: column;\n}\n\n.progress_bar {\n  height: 80px !important;\n  width: 80px !important;\n  padding: 8px;\n}\n.plan_card_mobile {\n  background-color: #0c08ce;\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  color: white;\n  padding: 8px;\n}\n.progress_bar_left {\n  height: 80px !important;\n  width: 80px !important;\n}\n\n.post_job {\n  padding: 32px 28px;\n  border-radius: 15px;\n  background-color: white;\n}\na {\n  text-decoration: none !important;\n  color:#a020f0;\n}\n\n.bcrumb:hover {\n  border-bottom: solid 1px #a020f0;\n \n}\n.help:hover {\n  text-decoration: underline;\n \n}\n\n.cookLogin {\n  background-image: url(\"./Assets/Images/4105860_2152177.jpg\");\n  height: auto;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n\n.cookSignup {\n  \n  height: 80vh;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n\n\ninput[type=\"switch\"] {\n  background-color: #000000;\n}\n\n.loginBox {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\neye_icon_login {\n  position: absolute;\n  top: 50%;\n  right: 5%;\n  transform: translate(-15%, -50%);\n  transition: all 0.4s ease-in-out;\n  font-size: 20px;\n  color: black;\n}\n\n.eye_icon_login:hover {\n  background-color: #dbdbdb;\n  padding: 3px;\n  font-size: 20px;\n  border-radius: 50%;\n}\n\ninput.input1::placeholder {\n  color: #c4c4c4;\n  \n}\ntextarea.input1::placeholder\n{\n  color:#c4c4c4;\n}\n\nselect {\n  appearance: menulist !important;\n}\n\n.home-img {\n  height: 40px;\n  width: 40px;\n}\n\n.home-text {\n  font-size: 16px;\n}\n\n.edit_button_profile {\n  height: 6dvh;\n  width: 100%;\n  margin-top: 4dvh;\n  margin-bottom: 3dvh;\n  background-color: black;\n  border: none;\n  border-radius: 15px;\n  font-size: 2.5dvh;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n.edit_button_profile:hover {\n  height: 6dvh;\n  width: 100%;\n  /* margin-top: 4dvh;\n  margin-bottom: 3dvh; */\n  border-radius: 15px;\n  border: 2px solid #ff5c09;\n  background-color: white;\n  font-size: 2.5dvh;\n  color: black;\n  font-weight: 600;\n}\n\n.offcanvas {\n  max-width: 80%;\n}\n.cards {\n  border-radius: 15px;\n  background-color: #ffffff;\n}\n\n/* .swiper-button-next,\n.swiper-button-prev {\n  background-image: url(./Assets//Images//next.png); */\n/*background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center; */\n/* color: red !important;\n font-size: 50px !important;\n height: 4px !important;\n width: 4px !important;\n} */\n\n.swiper-button-next::after {\n  /* border: 2px solid red;\n  height: 50px !important;\n  width: 50px !important;\n  color: red !important; */\n  font-size: 18px !important;\n  color: #ff5c09;\n  font-weight: 800 !important;\n\n\n  /* background-image: url(./Assets/Images/next.png) !important; */\n}\n.swiper-button-prev::after {\n  /* border: 2px solid red;\n  height: 50px !important;\n  width: 50px !important;\n  color: red !important; */\n  font-size: 18px !important;\n  color: #ff5c09;\n  font-weight: 800 !important;\n\n\n  /* background-image: url(./Assets/Images/next.png) !important; */\n}\n\n.card\n{\n  border:none !important;\n  border-radius: 10px;\n}\n\n.card-header\n{\n  border-top-right-radius: 10px !important;\n  border-top-left-radius: 10px !important;\n}\n\n\n\n\n.label {\n  font-weight:500;\n  color:#989898;\n}\n\n.rdo {\n  \n  margin: 20px;\n}\n\n\n\n.rbt-token\n{\ncolor:#000 !important;\nbackground-color:#f8ccb6 !important\n}\n.rbt\n{\n  border:none !important;\n}\n\n.cookSkills .rbt-token\n{\ncolor:#000 !important;\nbackground-color:#f8ccb600 !important;\nborder: 1px gray solid;\nborder-radius: 40px;\n}\n.cookSkills .rbt\n{\n  border:none !important;\n}\n\n.form-control\n{\n  display: block;\n    width: 100%;\n    /* padding: 0.375rem 0.75rem; */\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    padding-top:-10px !important;\n    /* color: var(--bs-body-color); */\n    appearance: none;\n    border: none !important;\n    border-bottom: 1px solid #989898 !important;\n    border-radius: 0 !important;\n    transition: none !important;\n}\n\n.orange\n{\n  color:#ff5c09;\n}\n\n.text-heading\n{\n  color:#4b4a4a;\n  font-size:14px;\n}\n.text-details\n{\n  color:#000000;\n  margin-top:-15px;\n  font-weight:500;\n  text-wrap: wrap;\n}\n\n.label {\n  font-weight:500;\n  color:#989898;\n}\n\n.rbt-aux\n{\n  display:none !important;\n}\n\n.is-valid, .is-invalid\n{\n  background-image: none !important;\n}\n.form-check-input:checked\n{\n  background-color: #ff5c09;\n  border-color: #ff5c09;\n\n}\n\n.switchButton\n{\n  margin-top:60px;\n  margin-left:-130px;\n}\n.label1 {\n  font-weight:500;\n  color:#989898;\n  margin-bottom: 10px;\n}\n\n\n.circle1,\n.circle2 {\n  background: white;\n  background: linear-gradient(\n      to right bottom,\n      rgba(255, 255, 255, 0.9),\n      rgba(255, 255, 255, 0.1)\n  );\n  height: 15rem;\n  width: 15rem;\n  position: absolute;\n  border-radius: 50%;\n}\n\n.circle1 {\n  top: 10%;\n  left: 10%;\n  transform: translate(-10%, -10%);\n}\n\n.circle2 {\n  top: 90%;\n  left: 40%;\n  transform: translate(-50%, -50%);\n}\n\n::-webkit-scrollbar {\n  width: 0;  /* Remove scrollbar space */\n  background: transparent;  /* Optional: just make scrollbar invisible */\n}\n.flex-container\n{\n  width: auto;\n  position: relative;\n  overflow: auto;\n  z-index: 1;\n}\n.navIcon\n{\n  height:17px;\n  width:17px;\n  margin-bottom: 3px;\n}\n.cancelBtn\n{\n  background-color: white !important;\n  border: 1px solid #ff5c09 !important;\n  color: #ff5c09;\n  box-shadow: none;\n  border-radius: 10px;\n  width: 130px;\n  height: 40px;\n\n  font-size: 18px;\n}\n\n.cancelBtn:hover,\n.cancelBtn:focus {\n  height: 41px;\n  width: 131px;\n  background-color: white !important;\n  border: 1px solid #ff5c09 !important;\n  color: #ff5c09 !important;\n  box-shadow: 0 0 5px #989898; /* Add appropriate box-shadow values */\n}\n\n.saveBtn\n{\n  background-color: #ff5c09 !important;\n  border: 1px solid #fff !important;\n  color: #fff;\n  box-shadow: none;\n  border-radius: 10px;\n  width: 130px;\n  height: 40px;\n  font-size: 18px;\n}\n\n\n.notfoundbtn{\n  background-color:blue !important;\n  border: 1px solid #fff !important;\n  color: #fff;\n  box-shadow: none;\n  border-radius: 10px;\n  width:200px;\n  height: 40px;\n  font-size: 18px;\n}\n\n.saveBtn:hover {\n  height: 41px ;\n  width: 131px;\n  background-color: #ff5c09 !important;\n  box-shadow: #989898;\n  border:none;\n\n}\n\n.apply_btn\n{\n  background-color: #ff5c09 !important;\n  border: 1px solid #fff !important;\n  color: #fff;\n  box-shadow: none;\n  border-radius: 10px;\n  width: 100px;\n  height: 40px;\n\n  font-size: 18px;\n}\n\n\n.apply_btn:hover {\n  height: 40px ;\n  width: 100px;\n  background-color: #ff5c09 !important;\n  box-shadow: #989898;\n  border:none;\n\n}\n\n\n.cancel_btn\n{\n  background-color: white !important;\n  border: 1px solid #ff5c09 !important;\n  color: #ff5c09;\n  box-shadow: none;\n  border-radius: 10px;\n  width: 100px;\n  height: 40px;\n  font-size: 18px;\n}\n.cancel_btn:hover {\n  height: 41px ;\n  width: 101px;\n  background-color: white !important;\n  border: 1px solid #ff5c09 !important;\n  color: #ff5c09 !important;\n  box-shadow: #989898;\n\n}\n\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.homeCard{\nborder-radius: 10px;\nbackground: white;\npadding:12px 5px;\nmargin:5px;\nbox-shadow: 0 5px 15px rgba(145, 92, 182,0.2);\nheight:auto;\n}\n.homeCard:hover\n{\n  box-shadow: 0 5px 15px rgba(145, 92, 182, .4);\n}\n.detailCard\n{\n  width:49%;\n}\n\n@media (max-width: 767px) {\n\n.detailCard\n{\n  width:98%;\n}\n}\n\n.homeIcon\n{\n  height:24px;\n  width:24px;\n}\n.contactCard{\n  border-radius: 10px;\n  background: white;\n  padding:6px 10px;\n  margin:5px;\n  width:45px;\n  box-shadow: 0 5px 15px rgba(145, 92, 182, .2);\n  }\n  .contactCard:hover{\n    box-shadow: 0 5px 15px rgba(145, 92, 182, .4);\n    }\ntd\n{\n  font-size: 14px;\n}\n.active>.page-link, .page-link.active\n{\n  background-color: #ff5c09;\n  border: none;\n}\n.page-link\n{\n  color:#ff5c09\n}\n .active\n {\n  color:#ff5c09\n }\n.multi-range-slider .ruler {\n\tmargin: 10px 0px -5px 0px;\n\t/* display: flex; */\n\tdisplay: none !important;\n\toverflow: hidden;\n}\n.cookjob\n{\n  width:32%;\n}\n.progress-bar\n{\n  background-color: #ff5c09;\n  border-radius: 20px;\n}\n.modal-header\n{\n  border-bottom:none;\n}\n\n.modal-footer\n{\n  border-top:none;\n  justify-content: flex-start;\n}\n\ninput#session-date{\n  position:relative;\n  overflow:hidden;\n}\ninput#session-date::-webkit-calendar-picker-indicator{\n  display:block;\n  top:0;\n  left:0;\n  background: #0000;\n  position:absolute;\n  transform: scale(12)\n}\n\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active\n{\n  border-bottom: 3px solid #ff5c09;\n \n  }\n  .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {\n    color: #ff5c09;\n      background-color: #fff;\n      border-bottom: solid 3px #ff5c09 !important;\n      border:none;\n  }\n  .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n    border-color : none;\n  }\n\n  .nav-link\n  {\n    color:#000;\n  }\n\n.plan-card {\n  display: inline-block;\n  /* Add any other styling for your column */\n}\n\n/* Media query for mobile view */\n@media (max-width: 768px) {\n  .plan-card {\n    overflow-x: scroll;\n  }\n}\n.container {\n  overflow-x: auto;\n  white-space: nowrap;\n}\n\n\n.planCard{\n\n  padding:8px 20px;\n  margin:5px;\n  \n  }\n\n  .react-loading-skeleton\n  {\n    border-radius: 10px;\n    background-color:#fff;\n    --highlight-color:#fff;\n    --base-color:#fafafa;\n   \n  }\n  .dropdown-toggle::after{\n   display:none;\n}\n.switch-handle {\n  position: absolute;\n \n  width: 28px;\n  height: 28px;\n  background: linear-gradient(to bottom, #FFFFFF 40%, #f0f0f0);\n  background-image: -webkit-linear-gradient(top, #FFFFFF 40%, #f0f0f0);\n  border-radius: 100%;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);\n}\n\n.switch-handle2 {\n  position: absolute;\n \n  width: 28px;\n  height: 28px;\n  background: linear-gradient(to bottom, #ff5c09 40%, #f0d9cd);\n  background-image: -webkit-linear-gradient(top, #ff5c09 40%, #f0d9cd);\n  border-radius: 100%;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);\n}\n\n.switch-handle:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -6px 0 0 -6px;\n  width: 12px;\n  height: 12px;\n  background: linear-gradient(to bottom, #eeeeee, #FFFFFF);\n  background-image: -webkit-linear-gradient(top, #eeeeee, #FFFFFF);\n  border-radius: 6px;\n  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);\n}\n.switch-handle2:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -6px 0 0 -6px;\n  width: 12px;\n  height: 12px;\n  background: linear-gradient(to bottom, #f0d9cd, #ff5c09);\n  background-image: -webkit-linear-gradient(top, #f0d9cd, #ff5c09);\n  border-radius: 6px;\n  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);\n}\n\n.switch-input:checked~.switch-handle {\n  left: 84px;\n  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);\n}\n\n/* Transition\n      ========================== */\n.switch-label,\n.switch-handle {\n  transition: All 0.3s ease;\n  -webkit-transition: All 0.3s ease;\n  -moz-transition: All 0.3s ease;\n  -o-transition: All 0.3s ease;\n}\n\n.swiper-3d .swiper-slide-shadow\n{\n  background:rgba(248,247,203,0.5) !important;\n}\n\n\n.modal-content {\n width:400px;\n max-height: auto;\n  padding: 20px;\n  text-align: left;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);\n  color: #666;\n  overflow-y: auto;\n \n}\n.select-no-border {\n  border: none;\n}\n\n.modal-title\n{\n  margin-top: -20px;\n  margin-left: -10px;\n  \n}\n.swiper-pagination-bullet\n\n{\n  width:20px !important;\n  border-radius: 10px !important;\n} \n\n.swiper-pagination-bullet-active\n{\n  background: #ff5c09 !important;\n}\n\n\n/* .show{\n  height: auto;\n  } */\n  .modal-backdrop.show\n  {\n    opacity: rgba(0,0,0,0.5);\n  }\n\n  .nav-link-item{\n \n    padding: 8px;\n    transition: all 0.3s ease-in-out;\n    color:#000;\n    font-weight: 500;\n}\n.invalid-feedback\n{\n  text-wrap: wrap ;\n}\n.text_container_child\n{\n  margin-top: 20%;\n}\n\n\n\n\n\n\n.rmsc .options {\n  max-height: 260px;\n  overflow-y: auto;\n  z-index: 1001;\n  margin: 0;\n  position: relative;\n  padding-left: 0;\n}\n\n\n.rmsc .options li {\n  list-style: none;\n  margin: 0;\n  position: relative;\n  z-index: 1001;\n\n}\n--------------\n\n\n\n[data-rsbs-overlay] {\n  border-top-left-radius: var(--rsbs-overlay-rounded);\n  border-top-right-radius: var(--rsbs-overlay-rounded);\n  display: flex;\n  background: var(--rsbs-bg);\n  flex-direction: column;\n  height: var(--rsbs-overlay-h);\n  transform: translate3d(0, var(--rsbs-overlay-translate-y), 0);\n  will-change: height;\n  background: #0c08ce;\n}\n[data-rsbs-overlay]:focus {\n  outline: none;\n}\n[data-rsbs-is-blocking='false'] [data-rsbs-overlay] {\n  box-shadow: 0 -5px 60px 0 rgba(38, 89, 115, 0.11),\n    0 -1px 0 rgba(38, 89, 115, 0.05);\n}\n[data-rsbs-overlay],\n[data-rsbs-root]:after {\n  max-width: var(--rsbs-max-w);\n  margin-left: var(--rsbs-ml);\n  margin-right: var(--rsbs-mr);\n}\n[data-rsbs-overlay],\n[data-rsbs-backdrop],\n[data-rsbs-root]:after {\n  z-index: 0;\n  overscroll-behavior: none;\n  touch-action: none;\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n}\n[data-rsbs-backdrop] {\n  top: -60px;\n  bottom: -60px;\n  background-color: var(--rsbs-backdrop-bg);\n  will-change: opacity;\n  cursor: pointer;\n  opacity: 1;\n}\n[data-rsbs-is-dismissable='false'] [data-rsbs-backdrop] {\n  cursor: ns-resize;\n}\n\n[data-rsbs-root]:after {\n  content: '';\n  pointer-events: none;\n  background: var(--rsbs-bg);\n  height: 1px;\n  transform-origin: bottom;\n  transform: scale3d(1, var(--rsbs-antigap-scale-y), 1);\n  will-change: transform;\n}\n[data-rsbs-footer],\n[data-rsbs-header] {\n  flex-shrink: 0;\n  cursor: ns-resize;\n  padding: 16px;\n}\n[data-rsbs-header] {\n  text-align: center;\n  user-select: none;\n  box-shadow: 0 1px 0\n    rgba(46, 59, 66, calc(var(--rsbs-content-opacity) * 0.125));\n  z-index: 0;\n  padding-top: calc(20px + env(safe-area-inset-top));\n  padding-bottom: 8px;\n}\n[data-rsbs-header]:before {\n  position: absolute;\n  content: '';\n  display: block;\n  width: 36px;\n  height: 4px;\n  top: calc(8px + env(safe-area-inset-top));\n  left: 50%;\n  transform: translateX(-50%);\n  border-radius: 2px;\n  background-color: var(--rsbs-handle-bg);\n}\n@media (min-resolution: 2dppx) {\n  [data-rsbs-header]:before {\n    transform: translateX(-50%) scaleY(0.75);\n  }\n}\n[data-rsbs-has-header='false'] [data-rsbs-header] {\n  box-shadow: none;\n  padding-top: calc(12px + env(safe-area-inset-top));\n}\n[data-rsbs-scroll] {\n  flex-shrink: 1;\n  flex-grow: 1;\n  -webkit-tap-highlight-color: revert;\n  -webkit-touch-callout: revert;\n  -webkit-user-select: auto;\n  -ms-user-select: auto;\n  user-select: auto;\n  overflow: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n[data-rsbs-scroll]:focus {\n  outline: none;\n}\n[data-rsbs-has-footer='false'] [data-rsbs-content] {\n  padding-bottom: env(safe-area-inset-bottom);\n}\n[data-rsbs-content] {\n  /* The overflow hidden is to ensure any margin on child nodes are included when the resize observer is measuring the height */\n  overflow: hidden;\n}\n[data-rsbs-footer] {\n  box-shadow: 0 -1px 0 rgba(46, 59, 66, calc(var(--rsbs-content-opacity) * 0.125)),\n    0 2px 0 var(--rsbs-bg);\n  overflow: hidden;\n  z-index:-1;\n  padding-bottom: calc(16px + env(safe-area-inset-bottom));\n}\n\n[data-rsbs-is-dismissable='true'],\n[data-rsbs-is-dismissable='false']:matches([data-rsbs-state='opening'], [data-rsbs-state='closing']) {\n  & :matches([data-rsbs-header], [data-rsbs-scroll], [data-rsbs-footer]) > * {\n    opacity: var(--rsbs-content-opacity);\n  }\n  & [data-rsbs-backdrop] {\n    opacity: var(--rsbs-backdrop-opacity);\n  }\n}\n\n[data-rsbs-state='closed'],\n[data-rsbs-state='closing'] {\n  /* Allows interactions on the rest of the page before the close transition is finished */\n  pointer-events: none;\n}\n\n[data-rsbs-overlay] {\n  border-top-left-radius: var(--rsbs-overlay-rounded);\n  border-top-right-radius: var(--rsbs-overlay-rounded);\n  display: flex;\n  background: var(--rsbs-bg);\n  flex-direction: column;\n  height: var(--rsbs-overlay-h);\n  transform: translate3d(0, var(--rsbs-overlay-translate-y), 0);\n  will-change: height;\n}\n[data-rsbs-overlay]:focus {\n  outline: none;\n}\n[data-rsbs-is-blocking='false'] [data-rsbs-overlay] {\n  box-shadow: 0 -5px 60px 0 rgba(38, 89, 115, 0.11),\n    0 -1px 0 rgba(38, 89, 115, 0.05);\n}\n[data-rsbs-overlay],\n[data-rsbs-root]:after {\n  max-width: var(--rsbs-max-w);\n  margin-left: var(--rsbs-ml);\n  margin-right: var(--rsbs-mr);\n}\n[data-rsbs-overlay],\n[data-rsbs-backdrop],\n[data-rsbs-root]:after {\n  z-index: -1;\n  overscroll-behavior: none;\n  touch-action: none;\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n}\n[data-rsbs-backdrop] {\n  top: -60px;\n  bottom: -60px;\n  background-color: var(--rsbs-backdrop-bg);\n  will-change: opacity;\n  cursor: pointer;\n  opacity: 1;\n}\n[data-rsbs-is-dismissable='false'] [data-rsbs-backdrop] {\n  cursor: ns-resize;\n}\n\n[data-rsbs-root]:after {\n  content: '';\n  pointer-events: none;\n  background: var(--rsbs-bg);\n  height: 1px;\n  transform-origin: bottom;\n  transform: scale3d(1, var(--rsbs-antigap-scale-y), 1);\n  will-change: transform;\n}\n[data-rsbs-footer],\n[data-rsbs-header] {\n  flex-shrink: 0;\n  cursor: ns-resize;\n  padding: 16px;\n}\n[data-rsbs-header] {\n  text-align: center;\n  user-select: none;\n  box-shadow: 0 1px 0\n    rgba(46, 59, 66, calc(var(--rsbs-content-opacity) * 0.125));\n  z-index: -1;\n  padding-top: calc(20px + env(safe-area-inset-top));\n  padding-bottom: 8px;\n}\n[data-rsbs-header]:before {\n  position: absolute;\n  content: '';\n  display: block;\n  width: 36px;\n  height: 4px;\n  top: calc(8px + env(safe-area-inset-top));\n  left: 50%;\n  transform: translateX(-50%);\n  border-radius: 2px;\n  background-color: var(--rsbs-handle-bg);\n}\n@media (min-resolution: 2dppx) {\n  [data-rsbs-header]:before {\n    transform: translateX(-50%) scaleY(0.75);\n  }\n}\n[data-rsbs-has-header='false'] [data-rsbs-header] {\n  box-shadow: none;\n  padding-top: calc(12px + env(safe-area-inset-top));\n}\n[data-rsbs-scroll] {\n  flex-shrink: 1;\n  flex-grow: 1;\n  -webkit-tap-highlight-color: revert;\n  -webkit-touch-callout: revert;\n  -webkit-user-select: auto;\n  -ms-user-select: auto;\n  user-select: auto;\n  overflow: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n[data-rsbs-scroll]:focus {\n  outline: none;\n}\n[data-rsbs-has-footer='false'] [data-rsbs-content] {\n  padding-bottom: env(safe-area-inset-bottom);\n}\n[data-rsbs-content] {\n  /* The overflow hidden is to ensure any margin on child nodes are included when the resize observer is measuring the height */\n  overflow: hidden;\n}\n[data-rsbs-footer] {\n  box-shadow: 0 -1px 0 rgba(46, 59, 66, calc(var(--rsbs-content-opacity) * 0.125)),\n    0 2px 0 var(--rsbs-bg);\n  overflow: hidden;\n  z-index: -1;\n  padding-bottom: calc(16px + env(safe-area-inset-bottom));\n}\n\n[data-rsbs-is-dismissable='true'],\n[data-rsbs-is-dismissable='false']:matches([data-rsbs-state='opening'], [data-rsbs-state='closing']) {\n  & :matches([data-rsbs-header], [data-rsbs-scroll], [data-rsbs-footer]) > * {\n    opacity: var(--rsbs-content-opacity);\n  }\n  & [data-rsbs-backdrop] {\n    opacity: var(--rsbs-backdrop-opacity);\n  }\n}\n\n[data-rsbs-state='closed'],\n[data-rsbs-state='closing'] {\n  /* Allows interactions on the rest of the page before the close transition is finished */\n  pointer-events: none;\n}\n\n\n\n/* Testimonial */\n\n.carousel-root {\n  width: 100% !important;\n  margin: auto !important;\n  margin-top: 3% !important;\n}\n\n.carousel .slide {\n  background: #fff !important;\n  color: black;\n  height: 100%;\n}\n\n.carousel .slide img {\n  width: 100px !important;\n  height: 100px !important;\n  border-radius: 50%;\n}\n\n\n\n\n.myCarousel h3 {\n  color: #222;\n  font-weight: 100;\n  letter-spacing: 0.2px;\n  margin-bottom: 4px;\n  font-weight: 600;\n \n  font-size: 17px;\n}\n\n.myCarousel h4 {\n\n  margin-top: 0;\n  padding-top: 0;\n  font-weight: 500;\n  color: #787878;\n  font-size: 14px;\n}\n\n.myCarousel p {\n  font-weight: 100 !important;\n  line-height: 29px !important;\n  color: #222;\n  font-size: 15px;\n  font-family: sans-serif;\n  max-height: 67px;\n}\n\n.myCarousel p:before {\n  content: \"“\";\n  color: #aaa;\n  font-size: 26px;\n  font-family: monospace;\n  font-weight: 100;\n}\n\n.myCarousel p:after {\n  content: \"”\";\n  color: #aaa;\n  font-size: 26px;\n  font-family: monospace;\n  font-weight: 100;\n  line-height: 0;\n}\n\n.carousel .control-dots .dot {\n  box-shadow: none !important;\n  background: #454545 !important;\n  outline: 0;\n}\n\n.carousel.carousel-slider .control-arrow {\n  background: #000 !important;\n  height: 50px !important;\n  position: absolute;\n  top: 35% !important;\n}\n\n.App {\n  text-align: center;\n}\n\n@media only screen and (min-width: 934px) {\n  .carousel-root {\n    outline: 0;\n    width: 95% !important;\n    margin: auto !important;\n  }\n\n  .carousel.carousel-slider .control-arrow {\n    display: none !important;\n  }\n  .myCarousel {\n    background: #fafafa;\n    margin-top: -9%;\n    width: 98%;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 8%;\n    padding-bottom: 12.5%;\n    padding-left: 5%;\n    padding-right: 5%;\n    border: 1px solid #ddd;\n    height: 220px;\n  }\n\n  .carousel .slide img {\n    width: 70px !important;\n    height: 70px !important;\n    border-radius: 50%;\n  }\n}\n\n.carousel.carousel-slider .control-arrow\n{\n  display: none;\n}\n\n\n.btn-primary:hover\n{\n  background-color: #ff5c09 ;\n  border:none;\n}\n\n.overviewcard\n{\n  width: 100%;\n  height: 64px;\n  background-color: white;\n  display: flex;\n  justify-content: flex-start;\n  align-items:center;\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.overviewcardContact\n{\n  width: 100%;\n  height: 20px;\n  background-color: white;\n  display: flex;\n\n  padding: 10px 10px 10px 40px;\n\n}\n\n.overviewcircle{\n \n    height: 40px;\n    width: 40px;\n    border-radius: 50%;\n    background-color: #f4f4f4;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    \n\n}\n\n.overviewcircleContact{\n\n    background-color: #ffffff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding:2px;\n    margin-right: 5px;\n\n}\n@media (min-width: 767px) {\n.contacticonCard{\n  margin-top: -60px;\n  align-content: end;\n  justify-content: end;\n}\n}\n@media (min-width: 767px) {\n  .jobCard{\n    margin-top: -20px;\n    align-content: end;\n  }\n  }\n\n  body {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\nfooter{\n    margin-top: auto;\n}\n\n.modalcancelBtn\n{\n  background-color: white !important;\n  border: 1px solid #ff5c09 !important;\n  color: #ff5c09 !important;\n  box-shadow: none;\n  border-radius: 10px;\n  width: 80px;\n  height: 35px;\n  font-size: 14px;\n}\n.modalcancelBtn:hover {\n  width: 81px;\n  height: 36px;\n  font-size: 14px;\n  background-color: white !important;\n  border: 1px solid #ff5c09 !important;\n  color: #ff5c09 !important;\n  box-shadow: #989898;\n\n}\n\n.modalsaveBtn\n{\n  background-color: #ff5c09 !important;\n  border: 1px solid #ff5c09 !important;\n  color: #fff;\n  box-shadow: none;\n  border-radius: 10px;\n  width: 80px;\n  height: 35px;\n  font-size: 14px;\n}\n.modalsaveBtn:hover {\n  width: 81px;\n  height: 36px;\n  font-size: 14px;\n  background-color: #ff5c09 !important;\n  border: 1px solid #ff5c09 !important;\n  color: #fff;\n  box-shadow: #989898;\n\n}\n\n.main-footer {\n  width: 100%;\n  z-index: 10;\n  bottom: 0;\n  padding: 0;\n  border-top: 0;\n}\n\n.newTag\n{\nmargin-top: -20px; \nmargin-left: -28px;\n}\n\n@media (max-width: 767px) {\n  .newTag\n  {\n  margin-top: -20px; \n  margin-left: -28px;\n  }\n  .filter{\n    width:100%;\n  }\n}\n\n@media (max-width: 920px) {\n  .newTag\n  {\n  margin-top: -90px;  \n  margin-left: -28px;\n  }\n  .filter{\n    width:100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .newTag\n  {\n  margin-top: -20px;  \n  margin-left: -28px;\n  }\n  .filter{\n    width:100%;\n  }\n}\n\n.jobcancelBtn\n{\n  background-color: white !important;\n  border: 1px solid #ff5c09 !important;\n  color: #ff5c09;\n  box-shadow: none;\n  border-radius: 10px;\n  width: 110px;\n  height: 35px;\n  font-size: 14px;\n}\n.jobcancelBtn:hover {\n  width: 111px;\n  height: 36px;\n  font-size: 14px;\n  background-color: white !important;\n  border: 1px solid #ff5c09 !important;\n  color: #ff5c09 !important;\n  box-shadow: #989898;\n\n}\n\n.jobsaveBtn\n{\n  background-color: #ff5c09 !important;\n  border: 1px solid #ff5c09 !important;\n  color: #fff;\n  box-shadow: none;\n  border-radius: 10px;\n  width: 110px;\n  height: 35px;\n  font-size: 14px;\n}\n.jobsaveBtn:hover {\n  width: 111px;\n  height: 36px;\n  font-size: 14px;\n  background-color: #ff5c09 !important;\n  border: 1px solid #ff5c09 !important;\n  color: #fff;\n  box-shadow: #989898;\n\n}\n\n.editBtn{\n  background-color: #ff5c09 !important;\n  box-shadow: none;\n  border-radius: 5px;\n  font-size: 16px;\n  border: none;\n  width: 100px;\n  height: 30px;\n  color: white;\n\n}\n.editBtn:hover {\n  height: 31px ;\n  width: 101px;\n  background-color: #ff5c09 !important;\n  box-shadow: #989898;\n  border:none;\n  color: white;\n\n}\n\n.planBtn{\n    padding: 0;\n    margin: 0;\n    height: 42px;\n    width: 140px;\n    background-color: #3D39D8 !important;\n    border-radius: 36px;\n    border: none;\n\n}\n\n.planBtn:hover{\n \n  padding: 0;\n  margin: 0;\n  height: 45px;\n  width: 150px;\n  background-color: #3D39D8 !important;\n  border-radius: 36px;\n  border: none;\n\n}\n\n.editprofileBtn\n{\n  \n    background-color: #000 !important;\n    color: white !important;\n    border-radius: 10px;\n    box-shadow: none;\n    border: none;\n    width:110px;\n\n}\n\n.editprofileBtn:hover\n{\n  \n    background-color: #000 !important;\n    color: white !important;\n    border-radius: 10px;\n    box-shadow: none;\n    border: none;\n    width:111px;\n\n}\n@media (min-width: 921px) {\n.filter{\n  width:77%;\n}\n}\n\n.newTagJob\n{\nmargin-top: -25px; \nmargin-left: -28px;\n}\n\n@media (max-width: 767px) {\n  .newTagJob\n  {\n  margin-top: -25px; \n  margin-left: -28px;\n  }\n\n}\n\n@media (max-width: 920px) {\n  .newTagJob\n  {\n  margin-top: -25px;  \n  margin-left: -28px;\n  }\n\n}\n\n@media (max-width: 480px) {\n  .newTagJob\n  {\n  margin-top: -42px;  \n  margin-left: -28px;\n  }\n\n}\n\n.newTagEvent\n{\nmargin-top: -20px; \nmargin-left: -28px;\n}\n\n@media (max-widh: 767px) {\n  .newTagEvent\n  {\n  margin-top: -220px; \n  margin-left: -28px;\n  }\n\n}\n\n@media (max-width: 920px) {\n  .newTagEvent\n  {\n  margin-top: -20px;  \n  margin-left: -28px;\n  }\n\n}\n\n@media (max-width: 480px) {\n  .newTagEvent\n  {\n  margin-top: -20px;  \n  margin-left: -28px;\n  }\n\n}\n.sidebar-menu-nav-title\n{\n  font-size: 16px;\n}\n\n.table-hover>tbody>tr:hover>* {\n  background-color: #EFFFB2 ;\n}\n\n.table-hover tbody tr:hover {\n  background-color : #EFFFB2;\n}\n\n.table-hover tbody tr\n{\n  height:50px;\n  vertical-align: middle;\n}\n\ninput[type=\"file\"] {\n  display: none;\n}\n\n/* Style the custom button */\n.custom-button {\n  display: inline-block;\n  padding: 5px;\n  border-radius:5px;\n  background-color: #a020f0;\n  color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n}\n.custom-buttonProfile {\n  display: inline-block;\n  border-radius:150px;\n  color:#ff5c09;\n background: #f2f2f2;\n padding-left: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  height:25px;\n  width:25px;\n\n  margin-left: 80px;\n}\n\n.downloadBtn\n{\n  border: solid 1px #ff5c09 !important;\n  padding: 3px;\n  border-radius: 5px;\n  color: #ff5c09;\n}\n\n.tab-button {\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  padding: 10px 15px;\n  font-size: 16px;\n  margin-right: 10px;\n  color: #000;\n  border-bottom: 2px solid transparent;\n}\n\n.tab-button.disabled {\n  opacity: 0.5;\n  border-bottom-color: orangered;\n  pointer-events: none;\n}\n\n.tab-button:hover {\n  border-bottom-color: orangered; /* Change to desired hover color */\n}\n\n\n.downloadBtn:hover\n{\n  border: solid 1px #ff5c09 !important;\n  padding: 4px;\n  border-radius: 5px;\n  color: #ff5c09;\n}\n.breadcrumb-container {\n  background: #ff5c09;\n  /* background: radial-gradient(circle, rgba(9,34,255,0.5) 57%, rgba(255,255,255,1) 100%); */\n  width: 100%;\n  height: 100px;\n \n  color:#fff;\n}\n.breadcrumb-containerabout{\n \n    background: #ff5c09;\n    /* background: radial-gradient(circle, rgba(9,34,255,0.5) 57%, rgba(255,255,255,1) 100%); */\n    width: 100%;\n    height: 60px;\n   \n    color:#fff;\n  }\n.bottom-div {\n\n  z-index: 9;\n  margin-top: 150px;\n  background-color: #fff;\n}\n\n\n.text-grad {\n  background:radial-gradient(circle, #ff5c09 0%, #a020f0);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.hero-sub-title {\n  line-height: 1.2;\n  display: inline-block;\n  color: #a020f0;\n  font-size: 1.75rem;\n  \n}\n\n.overviewcardAbout\n{\n  width: 95%;\n  height: auto;\n  background-color: #fbfbfb;\n  display: flex;\n  justify-content: flex-start;\n  align-items:center;\n  margin-top: 10px;\n  padding: 15px ;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(145, 92, 182,0.2);\n}\n\nselect\n{\n    color: #000;\n}\noption\n{\n    color: #000;\n}\noption:first-child\n{\n    color: #000;\n}\n/* .pagination li:last-child {\n  display: none;\n} */\n\n.myCarousel1 {\n  background: #f3f8ff;\n  margin-top: -12%;\n  width: 98%;\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 6%;\n  padding-bottom: 8%;\n  padding-left: 5%;\n  padding-right: 5%;\n  border: 1px solid #ddd;\n  height: 17dvh;\n  border-radius: 10px;\n}\n\n.cookCard{\n  border-radius: 10px;\n  background: #f9f9f9;\n  padding:12px 5px;\n  margin:5px;\n\n\n  }\n  .cookCard:hover\n  {\n    box-shadow: 0 5px 15px rgba(145, 92, 182, .4);\n  }\n\n  .webBtn1\n  {\n    background-color: rgba(255, 92, 9,0.9) !important;\n    border:none;\n    box-shadow: none;\n    text-transform: capitalize;\n    color: #fff;\n    height: 42px;\n    width: 120px;\n    font-size: 1em;\n    padding: 0px 20px;\n    border-radius: 15px;\n  }\n\n  .webBtn1:hover\n  {\n    background-color: rgb(255, 92, 9) !important;\n    border: solid 3px rgb(255, 92, 9) !important;\n  }\n\n  .webBtn2\n  {\n    background-color: #fff;\n    border:solid 1px rgba(255, 92, 9,0.9) !important;\n    box-shadow: none;\n    text-transform: capitalize;\n    color: #ff5c09;\n    height: 42px;\n    width: 120px;\n    font-size: 1em;\n    padding: 0px 20px;\n    border-radius: 15px;\n  }\n\n  .webBtn2:hover\n  {\n    background-color: rgba(255, 92, 9,0.9) !important;\n    border: none;\n    color:#fff;\n  }\n\n  .profileBtn {\n    height: 42px;\n    width: 120px;\n    padding: 0;\n    margin-top: 5px;\n    text-align: center;\n    font-size: 16px;\n    border: none;\n    background: rgba(255, 92, 9,0.9) !important;\n    border-radius: 14px;\n  }\n\n\n\n  .profileBtn:hover\n  {\n    background: #ff5c09 !important;\n  }\n\n  ::-ms-reveal {\n    display: none;\n}\n\n\n.btn-primary:hover {\n  background-color : none;\n  border-color : none;\n}\n.btn-primary:focus, .btn-primary.focus {\n  -webkit-box-shadow : 0 0 0 0.2rem rgba(102, 110, 232, 0.5);\n          box-shadow : 0 0 0 0.2rem rgba(102, 110, 232, 0.5);\n}\n.btn-primary.disabled, .btn-primary:disabled {\n  color : #FFFFFF;\n  background-color : #ff5c09;\n  border-color : #ff5c09;\n}\n.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {\n  color : #fff;\n  background-color : #fff;\n  border-color : #fff;\n}\n.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {\n  -webkit-box-shadow : 0 0 0 0.2rem rgba(102, 110, 232, 0.5);\n          box-shadow : 0 0 0 0.2rem rgba(102, 110, 232, 0.5);\n}\n\n\n.sticky-container {\n  position: fixed;\n  bottom: 20px; /* Adjust as needed */\n  left: 0;\n  width: 100%;\n  z-index: 1000; /* Ensure it's above other content */\n}\n\n.sticky-div {\n  background-color: #333;\n  color: white;\n  padding: 10px;\n  text-align: left;\n}\n\n.download-button {\n  padding: 10px 20px;\n  background-color: #0077B5;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  font-size: 18px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.close-button {\n  padding: 10px 20px;\n  background-color: #fff;\n  color: #000;\n  border: none;\n  border-radius: 5px;\n  font-size: 18px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.download-button:hover {\n  background-color: #005580;\n}\n\n.content {\n  padding: 20px;\n  /* Add some space at the bottom to prevent content from being hidden under the sticky div */\n  margin-bottom: 60px; /* Adjust according to the height of the sticky div */\n}\n\n.section-bg {\n  background: #fff9f1;\n}\n@media (min-width: 992px) {\n  .padding-tb {\n      padding: 110px 0;\n  }\n}\n@media (min-width: 1200px) {\n  .four-zero-section .four-zero-content .title {\n      font-size: 100px;\n      line-height: 1;\n  }\n}\n\n.lab-btn {\n  padding: 10px 30px;\n  background: #ff5c09;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-weight: 700;\n  color:#fff\n}\n.tablecontainer{\n  background-color: white;\n  align-items: center;\n}\n\n.table-custom {\n  border-collapse: separate;\n  border-spacing: 0;\n  padding: 40px;\n}\n\n.table-custom thead th {\n  border-bottom: 2px solid black;\n  /* Black line after the heading */\n}\n\n.borderBt-tr {\n  border-bottom: 2px solid black; \n  height: 100px !important;\n}\n\n.vertical-middle {\n  vertical-align: middle !important;\n}\n\n.view_btn\n{\n  background-color: #ff5c09 !important;\n  border: 1px solid #fff !important;\n  color: #fff;\n  box-shadow: none;\n  border-radius: 10px;\n  width: auto;\n  /* height: 40px; */\n  font-size: 16px;\n}\n\n\n.view_btn:hover {\n  /* height: 40px ; */\n  width: auto;\n  background-color: #ff5c09 !important;\n  box-shadow: #989898;\n  border:none;\n\n}\n\n.perks .item {\n  background-color: #F2F2F2;\n  padding: 20px;\n  padding: 10px 15px;\n  border-radius: 30px;\n  margin-right: 20px;\n  font-weight: 400;\n  cursor: pointer;\n}\n\n.perks .item-false {\n  background-color: #F2F2F2;\n  border: 1px solid  rgb(255, 92, 9);\n  padding: 10px 15px;\n  border-radius: 30px;\n  color: rgb(255, 92, 9);\n  margin-right: 20px;\n  font-weight: 400;\n  cursor: pointer;\n}\n\n.perks .item-job {\n  background-color: #F2F2F2;\n  border: 1px solid rgb(255, 92, 9);\n  padding: 5px 5px;\n  border-radius: 30px;\n  color: rgb(255, 92, 9);\n  font-weight: 400;\n  font-size: 14px;\n  display: flex;\n  margin-bottom: 10px;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.perks .item-ejob {\n  background-color: #F2F2F2;\n  border: 1px solid rgb(255, 92, 9);\n  padding: 5px 5px;\n  border-radius: 30px;\n  color: rgb(255, 92, 9);\n  font-weight: 400;\n  font-size: 12px;\n  display: flex;\n  margin-bottom: 10px;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.perks .item-false .icon {\n  color: rgb(255, 92, 9);\n  font-size: 25px;\n}\n\n.perks .item-job .icon {\n  color: rgb(255, 92, 9);\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.perks .item .icon {\n  font-size: 25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
